{
  "app": {
    "newUpdateAvailable": "Nueva actualización disponible",
    "newUpdateAvailableDescription": "Por favor, recarga la aplicación para obtener la última versión",
    "reloadApp": "Recargar aplicación",
    "cancel": "Cancelar",
    "error": {
      "title": "Algo salió mal",
      "message": "Ocurrió un error inesperado. Por favor, intenta de nuevo.",
      "takeMeHome": "Llévame a casa"
    },
    "sessionExpired": {
      "title": "Sesión expirada",
      "message": "Tu sesión ha expirado. Por favor, inicia sesión de nuevo.",
      "ok": "OK"
    }
  },
  "ExpoUpdateBottomSheet": {
    "title": "Hay una nueva actualización disponible",
    "description": "Actualiza ahora para obtener las últimas funciones, mejoras y correcciones de errores.",
    "apply": "Actualizar",
    "cancel": "Cancelar"
  },
  "BetaEndedModal": {
    "title": "La beta ha finalizado",
    "body": "¡Muchas gracias por ser parte de la beta de Squire! Esperamos que hayas disfrutado esta vista anticipada.",
    "reassurance": "No te preocupes: no perderás ninguno de tus datos.",
    "downloadButtonIos": "Descargar desde la App Store",
    "downloadButtonAndroid": "Descargar desde Google Play",
    "accessibility": {
      "downloadButtonHint": "Abre la ficha de la aplicación en la tienda"
    }
  },
  "DevMenu": {
    "title": "Configuración de Dev",
    "buttonLabel": "😛",
    "clearStorage": "Borrar almacenamiento",
    "testErrorBoundary": "Probar límite de error",
    "triggerNPSSurvey": "Activar encuesta NPS",
    "triggerAppStoreReview": "Activar reseña de la App Store",
    "triggerRatingPrompt": "Activar aviso de calificación",
    "environment": "Entorno",
    "bnplVariant": "Variante de pago BNPL",
    "bnplVariantFromLaunchDarkly": "Usar LaunchDarkly",
    "bnplVariantControl": "Control",
    "bnplVariantPayLater": "Paga después",
    "bnplVariantNowLater": "Paga ahora / Paga después",
    "depositMock": "Simular depósito de reserva",
    "depositMockOff": "Desactivado",
    "depositMockRefundable": "Reembolsable",
    "depositMockNonRefundable": "No reembolsable",
    "appId": "ID de la App",
    "appVersion": "Versión de la App",
    "runtimeVersion": "Versión del Runtime",
    "appearance": "Apariencia",
    "light": "Claro",
    "dark": "Oscuro",
    "language": "Idioma",
    "actions": "Acciones",
    "toasts": "Toasts",
    "toastSuccess": "Toast de éxito",
    "toastError": "Toast de error",
    "toastInfo": "Toast informativo",
    "toastLong": "Toast largo",
    "toastSuccessMessage": "Tu cita está reservada",
    "toastErrorMessage": "No pudimos procesar tu pago",
    "toastInfoMessage": "Tu barbero llegará unos minutos tarde",
    "toastLongMessage": "No pudimos reservar este horario porque otro cliente acaba de tomarlo. Elige otro horario.",
    "toastLongDescription": "No se realizó ningún cargo a tu tarjeta."
  },
  "shared": {
    "locationPermission": {
      "denied": "Se denegó el permiso para acceder a la ubicación",
      "openSettings": "Abrir Configuración"
    },
    "photoPermission": {
      "cameraDenied": "Se denegó el permiso para acceder a la cámara",
      "libraryDenied": "Se denegó el permiso para acceder a la galería de fotos",
      "openSettings": "Abrir Configuración"
    },
    "openDirections": {
      "title": "Abrir en Maps",
      "description": "Elige tu aplicación de mapas preferida",
      "cancel": "Cancelar"
    },
    "resendOtpButton": {
      "resendCode": "Reenviar el código",
      "resendIn": "Reenviar en {{seconds}} s",
      "didNotReceiveCode": "¿No recibiste nada? Intenta de nuevo.",
      "accessibility": {
        "resendSection": "Opciones para reenviar código",
        "resendButton": "Reenviar código de verificación",
        "resendButtonHint": "Solicitar que se envíe un nuevo código de verificación a tu teléfono"
      }
    },
    "otpInput": {
      "accessibility": {
        "label": "Campo de código de verificación",
        "hint": "Ingresa el código de verificación"
      }
    },
    "screenHeader": {
      "backButton": {
        "accessibilityLabel": "Volver",
        "accessibilityHint": "Volver a la pantalla anterior"
      },
      "closeButton": {
        "accessibilityLabel": "Cerrar",
        "accessibilityHint": "Cerrar y volver a la pantalla anterior"
      },
      "widgetCloseButton": {
        "accessibilityLabel": "Cerrar widget",
        "accessibilityHint": "Cerrar el widget de reservas"
      },
      "languageButton": {
        "accessibilityLabel": "Cambiar idioma",
        "accessibilityHint": "Abre el selector de idioma"
      }
    },
    "validation": {
      "emailRequired": "El correo electrónico es obligatorio",
      "emailInvalid": "Por favor ingresa un correo electrónico válido"
    }
  },
  "HomeDrawer": {
    "greeting": "Hola, {{name}}",
    "viewProfile": "Ver perfil",
    "appointments": "Citas",
    "standby": "Lista de espera",
    "cards": "Tarjetas",
    "terms": "Términos",
    "privacy": "Privacidad",
    "support": "Soporte",
    "language": "Idioma",
    "signOut": "Cerrar sesión",
    "accessibility": {
      "closeDrawer": "Cerrar menú lateral",
      "profileSection": "Sección de perfil de usuario",
      "profileButton": "Ver perfil",
      "profileButtonHint": "Navegar a tu página de perfil",
      "menuSection": "Opciones del menú principal",
      "appointmentsButton": "Ver citas",
      "appointmentsButtonHint": "Navegar a tus citas",
      "standbyButton": "Lista de espera, {{count}} activas",
      "standbyButtonHint": "Navegar a tu lista de espera",
      "cardsButton": "Administrar tarjetas",
      "cardsButtonHint": "Navegar a tus tarjetas guardadas",
      "termsButton": "Ver términos y condiciones",
      "termsButtonHint": "Abrir términos de servicio",
      "privacyButton": "Ver política de privacidad",
      "privacyButtonHint": "Abrir política de privacidad",
      "supportButton": "Obtener ayuda y soporte",
      "supportButtonHint": "Contactar soporte al cliente",
      "languageButton": "Idioma",
      "languageButtonHint": "Cambiar idioma de la aplicación",
      "signOutButton": "Cerrar sesión de tu cuenta",
      "signOutButtonHint": "Cerrar sesión de la aplicación",
      "closeDrawerHint": "Cierra el menú lateral"
    }
  },
  "CardsScreen": {
    "title": "Tarjetas",
    "emptyTitle": "No tienes tarjetas guardadas",
    "invalidCard": "La tarjeta ya no es válida",
    "applePay": "Apple Pay",
    "expires": "Vence {{date}}",
    "error": "No se pudieron cargar las tarjetas",
    "tryAgain": "Intentar de nuevo",
    "setDefaultSuccess": "Método de pago predeterminado actualizado",
    "setDefaultErrorTitle": "No se pudo actualizar tu tarjeta predeterminada",
    "setDefaultErrorDescription": "Inténtalo de nuevo.",
    "removeCard": "Eliminar",
    "removeCardError": "No se pudo eliminar la tarjeta. Inténtalo de nuevo.",
    "removeCardErrorMarkedDefault": "Establece otra tarjeta como predeterminada antes de eliminar esta.",
    "removeCardErrorAttachedToAppointment": "No se puede eliminar esta tarjeta porque está asociada a una cita próxima.",
    "removeCardErrorUnfinishedSale": "Esta tarjeta se está usando para un pago que aún se está procesando. Podrás eliminarla cuando termine.",
    "addCard": "Agregar una tarjeta nueva",
    "addCardTitle": "Agregar una tarjeta nueva",
    "cardLabel": "Tarjeta",
    "makeDefault": "Establecer como predeterminada",
    "addCardConfirm": "Agregar tarjeta",
    "addCardError": "No se pudo agregar la tarjeta. Revisá los datos o probá con otra tarjeta.",
    "addCardSuccess": "La tarjeta se agregó correctamente",
    "cardLimitNotice": "Puedes guardar hasta {{limit}} tarjetas, desliza una tarjeta hacia la izquierda para eliminarla.",
    "accessibility": {
      "card": "Tarjeta terminada en {{last4}}",
      "removeCard": "Eliminar tarjeta terminada en {{last4}}"
    }
  },
  "RouteAnnouncer": {
    "chooseLocation": "Elegí una ubicación",
    "chooseProfessional": "Elegir Profesional",
    "chooseService": "Elegir Servicio",
    "chooseTime": "Elegir horario",
    "buyGiftCard": "Comprar una tarjeta de regalo"
  },
  "WaitingRoom": {
    "title": "SQUIRE no está disponible en este momento.",
    "message": "Cuando vuelva a estar disponible, te dejaremos entrar automáticamente...",
    "contactSupport": "Contactar a soporte",
    "closeButton": {
      "accessibilityLabel": "Cerrar widget",
      "accessibilityHint": "Cerrar el widget de reservas"
    }
  },
  "LanguageBottomSheet": {
    "title": "Idioma",
    "english": "English",
    "spanish": "Español",
    "french": "Français",
    "englishShort": "EN",
    "spanishShort": "ES",
    "frenchShort": "FR",
    "currentLanguage": "Idioma actual: {{language}}",
    "confirmButton": "Confirmar idioma",
    "languageUpdateError": "No pudimos actualizar tu idioma. Inténtalo de nuevo.",
    "languageNames": {
      "english": "Inglés",
      "spanish": "Español",
      "french": "Francés"
    },
    "accessibility": {
      "closeButton": "Cerrar selección de idioma",
      "closeButtonHint": "Cierra la selección de idioma",
      "selectLanguageHint": "Seleccionar {{language}} como idioma de la aplicación",
      "confirmButton": "Confirmar selección de idioma",
      "confirmButtonHint": "Aplicar el idioma seleccionado a la aplicación",
      "radioButton": "Botón de selección de {{language}}",
      "radioButtonSelected": "{{language}} está seleccionado actualmente"
    }
  },
  "AuthScreen": {
    "errorTitle": "Error",
    "title": "Crear una cuenta\no Iniciar sesión",
    "continueWithApple": "Continuar con Apple",
    "continueWithAppleLabel": "Continuar con Apple",
    "or": "O",
    "ok": "Ok",
    "signUp": "Registrarse",
    "signIn": "Iniciar sesión",
    "close": "Cerrar",
    "dataUsageInfo": "Al continuar, aceptas nuestros Términos de Servicio y Política de Privacidad",
    "appleSignInError": "Inicio de sesión con Apple falló. Por favor, inténtalo de nuevo.",
    "accessibility": {
      "closeButton": "Cerrar pantalla de autenticación",
      "closeButtonHint": "Regresa a la pantalla anterior",
      "authIcon": "Icono de autenticación",
      "appleSignInButton": "Continuar con Apple",
      "appleSignInButtonHint": "Inicia sesión usando tu Apple ID",
      "googleSignInButton": "Continuar con Google",
      "googleSignInButtonHint": "Inicia sesión usando tu cuenta de Google",
      "signUpButton": "Crear una nueva cuenta",
      "signUpButtonHint": "Navegar al flujo de registro",
      "signInButton": "Iniciar sesión con email",
      "signInButtonHint": "Navegar al flujo de inicio de sesión con email",
      "separator": "Separador O",
      "screen": "Pantalla de autenticación",
      "methods": "Métodos de autenticación",
      "loading": "Iniciando sesión"
    },
    "continueWithGoogle": "Continuar con Google",
    "continueWithGoogleLabel": "Continuar con Google",
    "signingInWithGoogle": "Iniciando sesión con Google..."
  },
  "LoginScreen": {
    "title": "Bienvenido!",
    "email": "Email",
    "signInToContinue": "Ingresá para continuar",
    "password": "Contraseña",
    "enterYourEmail": "Ingresá tu email",
    "enterYourPassword": "Ingresá tu contraseña",
    "signIn": "Ingresar"
  },
  "HomeScreen": {
    "welcome": "Bienvenido a Squire,\nencontrá una barbería cerca tuyo.",
    "signIn": "Registrarse / Iniciar sesión",
    "logIn": "Iniciar sesión",
    "giveFeedback": "Enviar comentarios",
    "nearby": "CERCA",
    "search": "BUSCAR",
    "book": "Reservar",
    "haveAppointment": "Tengo una cita",
    "openSupportEmailError": "Error al abrir el correo de soporte",
    "noEmailAppError": "No se encontró ninguna app de correo en este dispositivo. Instala una app de correo para contactar con soporte.",
    "seeMore": "¿Querés ver más?\nExplorá barberías",
    "location": "Ubicación",
    "locationDescription": "Necesitamos tu ubicación para encontrar barberías cerca tuyo",
    "continue": "Continuar",
    "title": "Elegí una ubicación",
    "searchPlaceholder": "Buscar barberías, barberos o marcas",
    "locationSearchPlaceholder": "Ingresar ubicación",
    "locationSearchNotice": "La vista de mapa no está disponible en esta versión. Aún puedes explorar las ubicaciones cercanas a continuación.",
    "getDirections": "Obtener direcciones",
    "noResults": "No se encontraron resultados",
    "noResultsDescription": "Intentá ajustar tus términos de búsqueda o verificar la ortografía",
    "startSearching": "Comenzá a escribir para buscar",
    "startSearchingDescription": "Buscar barberías, barberos\no marcas en tu área",
    "noOtherLocations": "No hay otras ubicaciones",
    "noOtherLocationsDescription": "Esta marca no tiene otras ubicaciones a las\nque puedas mover esta reserva",
    "location_one": "{{count}} Ubicación",
    "location_other": "{{count}} Ubicaciones",
    "searchResults": "RESULTADOS DE BÚSQUEDA",
    "noResultsFound": "No se encontraron resultados. Intentá\ncon un término diferente.",
    "accessibility": {
      "menuButton": "Abrir menú",
      "menuButtonHint": "Abre el menú de navegación principal",
      "signInButton": "Iniciar sesión",
      "signInButtonHint": "Inicia sesión en tu cuenta",
      "giveFeedbackButton": "Enviar comentarios",
      "giveFeedbackButtonHint": "Abre un correo para compartir comentarios sobre la app beta",
      "welcomeMessage": "Mensaje de bienvenida",
      "nearbyButton": "{{count}} barberías cercanas",
      "nearbyButtonActive": "Desactivar búsqueda cercana",
      "nearbyButtonInactive": "Encontrar barberías cerca de tu ubicación",
      "searchButton": "{{count}} barberías",
      "searchButtonHint": "Buscar barberías, barberos o marcas",
      "dismissLocationSearchNotice": "Descartar aviso",
      "searchResultButton": "Resultado de búsqueda: {{searchTerm}}",
      "searchResultButtonHint": "Limpiar búsqueda y volver a todas las barberías",
      "clearSearchButton": "Limpiar búsqueda",
      "clearSearchButtonHint": "Eliminar filtro de búsqueda actual",
      "appointmentButton": "Tengo una cita",
      "appointmentButtonHint": "Ver tus citas existentes",
      "barbershopCard": "{{name}}, ubicado en {{address}}, aproximadamente a {{distance}} de distancia",
      "barbershopCardHint": "Reservar una cita en esta barbería",
      "barbershopPhoto": "Foto de {{name}}",
      "bookButton": "Reservar cita en {{name}}",
      "bookButtonHint": "Programar una cita en esta barbería",
      "carouselList": "{{count}} barberías",
      "carouselListHint": "Desliza horizontalmente para explorar barberías",
      "seeMoreButton": "Ver más barberías",
      "seeMoreButtonHint": "Explorar más barberías"
    },
    "betaFeedbackEmail": {
      "subject": "Squire iOS Beta Feedback — {{appVersion}} (Build {{buildNumber}})",
      "descriptionPrompt": "¿De qué se trata?",
      "descriptionPlaceholder": "[Toca aquí para describir lo que pasó]",
      "reproStepsLabel": "Pasos para reproducir (si aplica):",
      "expectedLabel": "¿Qué esperabas que pasara?",
      "actualLabel": "¿Qué pasó realmente?",
      "screenshotPrompt": "Por favor, adjunta una captura de pantalla si puedes — ¡ayuda mucho!",
      "diagnosticsLabel": "Auto-included:",
      "deviceLabel": "Device",
      "appVersionLabel": "App Version",
      "buildNumberLabel": "Build Number",
      "userIdLabel": "User ID",
      "timestampLabel": "Timestamp"
    }
  },
  "PasswordRequirements": {
    "length": "Al menos 8 caracteres de largo",
    "letter": "Debe contener una letra",
    "specialChar": "Un número o carácter especial"
  },
  "SignUpAvatarScreen": {
    "title": "Una cosa más",
    "subtitle": "Configura tu foto de perfil\nsi lo deseas.",
    "avatarPlaceholder": "[La interfaz de selección de avatar se implementará aquí]",
    "selectAvatar": "Seleccionar Foto",
    "skip": "Lo haré más tarde",
    "uploadError": {
      "title": "Error de Carga",
      "message": "No se pudo cargar tu foto de perfil. Por favor, inténtalo de nuevo.",
      "noCustomerId": "No se puede cargar la foto en este momento. Por favor, inténtalo más tarde."
    },
    "galleryError": {
      "title": "Error de Galería",
      "message": "No se pudo seleccionar la foto. Por favor, inténtalo de nuevo."
    },
    "accessibility": {
      "selectAvatarButton": "Seleccionar foto de perfil",
      "selectAvatarButtonHint": "Elegir una foto para tu perfil",
      "skipButton": "Omitir agregar foto",
      "skipButtonHint": "Continuar sin agregar una foto de perfil",
      "screen": "Pantalla de selección de avatar"
    }
  },
  "SignUpEmailScreen": {
    "title": "Crear una cuenta",
    "email": "EMAIL",
    "emailLabel": "EMAIL",
    "emailPlaceholder": "Ingresa tu email",
    "password": "CONTRASEÑA",
    "passwordLabel": "CONTRASEÑA",
    "passwordPlaceholder": "Ingresa tu contraseña",
    "continue": "Continuar",
    "accessibility": {
      "closeButton": "Cerrar flujo de registro",
      "closeButtonHint": "Regresa a la pantalla anterior",
      "emailInput": "Dirección de email",
      "passwordInput": "Contraseña",
      "showPasswordButton": "Mostrar contraseña",
      "hidePasswordButton": "Ocultar contraseña",
      "continueButton": "Continuar al siguiente paso",
      "continueButtonHint": "Proceder a ingresar detalles personales"
    }
  },
  "SignUpSecondStepScreen": {
    "title": "Segundo paso",
    "subtitle": "Cuéntanos un poco\nmás sobre ti...",
    "firstNameLabel": "NOMBRE",
    "firstNamePlaceholder": "Nombre",
    "lastNameLabel": "APELLIDO",
    "lastNamePlaceholder": "Apellido",
    "phoneLabel": "TELÉFONO",
    "phonePlaceholder": "+1 (555) 123-4567",
    "phoneDescription": "Te enviaremos un código de verificación por SMS",
    "continue": "Continuar",
    "close": "Cerrar",
    "creatingAccount": "Creando cuenta...",
    "errorTitle": "Error",
    "validation": {
      "firstNameRequired": "El nombre es requerido",
      "firstNameInvalid": "El nombre no puede contener números",
      "lastNameRequired": "El apellido es requerido",
      "lastNameInvalid": "El apellido no puede contener números",
      "phoneInvalid": "Por favor ingresa un número de teléfono válido"
    },
    "errors": {
      "emailExists": "Ya existe una cuenta con este email. Por favor inicia sesión.",
      "invalidPhone": "Por favor ingresa un número de teléfono válido",
      "general": "Algo salió mal. Por favor intenta de nuevo."
    },
    "accessibility": {
      "backButton": "Volver",
      "backButtonHint": "Regresa al paso anterior",
      "closeButton": "Cerrar flujo de registro",
      "closeButtonHint": "Cancela el proceso de registro",
      "firstNameInput": "Nombre",
      "lastNameInput": "Apellido",
      "phoneInput": "Número de teléfono con código de país",
      "phoneInputHint": "Incluye código de país, ej., +1 para EE.UU.",
      "continueButton": "Crear cuenta y continuar",
      "continueButtonHint": "Crea tu cuenta y envía código de verificación"
    }
  },
  "SignUpOtpScreen": {
    "title": "Verifica por favor",
    "subtitle": "Te hemos enviado un código de 6 dígitos a tu teléfono",
    "otpLabel": "CODIGO DE 6 DIGITOS",
    "otpCode": "Código",
    "resendCode": "Reenviar el código",
    "didNotReceiveCode": "¿No recibiste nada? Intenta de nuevo.",
    "codeSent": "Código enviado",
    "validCode": "Código verificado",
    "invalidCode": "Código inválido",
    "accessibility": {
      "backButton": "Volver",
      "backButtonHint": "Regresa al paso anterior",
      "closeButton": "Cerrar registro",
      "closeButtonHint": "Cancela el proceso de registro",
      "otpInput": "Código de verificación de 6 dígitos",
      "otpInputHint": "Ingresa el código de verificación de 6 dígitos enviado a tu teléfono",
      "verifyButton": "Verificar código y continuar",
      "verifyButtonHint": "Verifica tu número de teléfono y procede al siguiente paso",
      "resendButton": "Reenviar código de verificación",
      "resendButtonHint": "Solicita que se envíe un nuevo código de verificación a tu teléfono",
      "resendSection": "Opciones para reenviar código",
      "phoneNumber": "Código enviado a {{phone}}",
      "otpForm": "Formulario de código de verificación"
    }
  },
  "SignUpConfirmationScreen": {
    "title": "¡Todo listo!",
    "subtitle": "Ya puedes ir a ver tu\npantalla principal.",
    "continue": "Comenzar",
    "accessibility": {
      "successIcon": "Creación de cuenta exitosa",
      "continueButton": "Continuar a la aplicación",
      "continueButtonHint": "Navegar a la aplicación principal",
      "screen": "Pantalla de confirmación de registro"
    }
  },
  "SignInEmailScreen": {
    "title": "Iniciar sesión",
    "subtitle": "Inicia sesión en tu cuenta\ncon tu dirección de email",
    "emailLabel": "EMAIL",
    "emailPlaceholder": "Ingresa tu email",
    "submitButton": "Enviar",
    "emailNotFound": "Esta cuenta no existe. Crea una cuenta o usa una dirección de email diferente.",
    "accessibility": {
      "emailInput": "Campo de entrada de dirección de email",
      "emailInputHint": "Ingresa la dirección de email asociada con tu cuenta",
      "submitButton": "Enviar email para verificación",
      "submitButtonHint": "Enviar código de verificación al número de teléfono registrado",
      "screen": "Pantalla de inicio de sesión con email"
    }
  },
  "SignInOtpScreen": {
    "title": "Iniciar sesión",
    "subtitle": "Te hemos enviado un código de verificación de 6 dígitos al teléfono que termina en {{phone}}",
    "subtitleEmail": "Te hemos enviado un código de verificación de 6 dígitos a tu correo electrónico",
    "otpLabel": "CÓDIGO DE 6 DÍGITOS",
    "otpCode": "Código",
    "codeSent": "Código enviado",
    "resendCode": "Reenviar el código",
    "didNotReceiveCode": "¿No recibiste nada? Intenta de nuevo.",
    "validCode": "Código verificado",
    "networkError": "Algo salió mal. Inténtalo de nuevo.",
    "invalidCode": "Código inválido",
    "accessibility": {
      "phoneNumber": "Código enviado al teléfono que termina en {{phone}}",
      "emailAddress": "Código enviado a tu correo electrónico",
      "otpForm": "Formulario de código de verificación",
      "otpInput": "Campo de entrada de código de verificación de 6 dígitos",
      "otpInputHint": "Ingresa el código de verificación de 6 dígitos enviado a tu teléfono",
      "resendButton": "Reenviar código de verificación",
      "resendButtonHint": "Solicitar que se envíe un nuevo código de verificación a tu teléfono",
      "resendSection": "Opciones para reenviar código",
      "screen": "Pantalla de verificación de inicio de sesión"
    }
  },
  "AccountDisabledScreen": {
    "title": "La cuenta está deshabilitada",
    "subtitle": "Si deseas iniciar sesión en tu cuenta, envía una solicitud para restaurarla",
    "disabledOn": "Deshabilitada el {{date}}",
    "restoreAction": "Restaurar cuenta",
    "cancelAction": "Cancelar",
    "restoreEmail": {
      "subject": "Restaurar cuenta",
      "bodyPrefix": "Por favor restaura mi cuenta con los siguientes datos:\nID de usuario: {{userId}}"
    },
    "accessibility": {
      "screen": "Pantalla de cuenta deshabilitada",
      "avatar": "Avatar del usuario",
      "restoreButton": "Restaurar cuenta",
      "restoreButtonHint": "Abre el correo de soporte para solicitar la restauración de la cuenta",
      "cancelButton": "Cancelar",
      "cancelButtonHint": "Volver al inicio de sesión"
    }
  },
  "LookUpScreen": {
    "title": "Buscar",
    "subtitle": "Ingresa tu código de confirmación de cita de 6 dígitos.",
    "invalidCode": "El código de confirmación o ID proporcionado es inválido.",
    "networkError": "Error de red. Por favor intenta de nuevo.",
    "loading": "Buscando cita...",
    "otpLabel": "CÓDIGO DE 6 DÍGITOS",
    "accessibility": {
      "otpInput": "Campo de código de confirmación de cita",
      "otpInputHint": "Ingresa tu código de confirmación de cita de 6 dígitos",
      "lookupForm": "Formulario de búsqueda de cita",
      "closeButton": "Cerrar pantalla de búsqueda de cita",
      "closeButtonHint": "Regresar a la pantalla anterior"
    }
  },
  "AppointmentHomeScreen": {
    "signIn": "Iniciar sesión",
    "viewMore": "Ver Más",
    "bookAgain": "Reservar de Nuevo",
    "bookNew": "Reservar una nueva cita",
    "withBarber": "con {{barberName}}",
    "upcomingAppointment": "PRÓXIMA CITA",
    "lastAppointment": "TU ÚLTIMA CITA",
    "welcomeMessage": "Hola {{name}}, es hora de reservar tu próxima cita.",
    "analyzingBookings": "Estamos analizando\nactivamente\ntus reservas…",
    "notifyToBook": "Te avisaremos\ncuando sea momento\nde reservar de nuevo",
    "noAppointmentData": "No hay datos de cita disponibles",
    "noAppointmentDataSubtitle": "Por favor, intenta buscar tu cita nuevamente.",
    "moreUpcomingAppointments_one": "{{count}} CITA PRÓXIMA MÁS",
    "moreUpcomingAppointments_other": "{{count}} CITAS PRÓXIMAS MÁS",
    "accessibility": {
      "appointmentHomeScreen": "Pantalla de inicio de citas",
      "signInButton": "Iniciar sesión en tu cuenta",
      "signInButtonHint": "Acceder a todas las funciones de tu cuenta",
      "viewMoreButton": "Ver más detalles de la cita",
      "viewMoreButtonHint": "Ver información adicional sobre esta cita",
      "bookAgainButton": "Reservar de nuevo en esta barbería",
      "bookAgainButtonHint": "Programar otra cita en la misma barbería",
      "bookingAgain": "Reservando de nuevo",
      "bookNewButton": "Reservar una nueva cita",
      "bookNewButtonHint": "Programar una nueva cita",
      "appointmentCard": "Tarjeta de detalles de la cita",
      "appointmentCardHint": "Muestra la información de tu cita"
    }
  },
  "AppointmentSignInScreen": {
    "title": "Iniciar sesión",
    "subtitle": "Inicia sesión en tu cuenta con tu número de teléfono o email.",
    "subtitlePhoneOnly": "Inicia sesión en tu cuenta con tu número de teléfono.",
    "subtitleEmailOnly": "Inicia sesión en tu cuenta con tu email.",
    "continueWith": "Continuar con {{contact}} →",
    "verificationMessage": "Te envaremos un código de verificación.",
    "supportMessage": "¿No reconoces el número de teléfono o email? Por favor contacta a tu barbería o support@getsquire.com.",
    "useDifferentAccount": "Usar una cuenta diferente",
    "close": "Cerrar",
    "noContactMethods": "No hay métodos de contacto disponibles",
    "accessibility": {
      "appointmentSignInScreen": "Pantalla de inicio de sesión de cita",
      "closeButton": "Cerrar pantalla de inicio de sesión",
      "closeButtonHint": "Regresar a los detalles de la cita",
      "phoneSignInButton": "Iniciar sesión con número de teléfono {{phone}}",
      "phoneSignInButtonHint": "Iniciar sesión usando tu número de teléfono registrado",
      "emailSignInButton": "Iniciar sesión con email {{email}}",
      "emailSignInButtonHint": "Iniciar sesión usando tu dirección de email registrada",
      "supportText": "Información de contacto de soporte",
      "useDifferentAccountButton": "Usar una cuenta diferente"
    }
  },
  "AppointmentLookupCompleteProfileBottomSheet": {
    "title": "Información\nrequerida",
    "subtitle": "Por tu seguridad, completa tu perfil a continuación",
    "firstNameLabel": "NOMBRE",
    "lastNameLabel": "APELLIDO",
    "phoneLabel": "TELÉFONO",
    "emailLabel": "EMAIL",
    "firstNamePlaceholder": "Nombre",
    "lastNamePlaceholder": "Apellido",
    "emailPlaceholder": "Email",
    "confirmButton": "Confirmar",
    "footerText": "El email y el número de teléfono que proporciones se usarán para las notificaciones de citas.",
    "accessibility": {
      "closeButton": "Cerrar formulario de completar perfil",
      "firstNameInput": "Campo de entrada de nombre",
      "lastNameInput": "Campo de entrada de apellido",
      "phoneInput": "Campo de entrada de número de teléfono",
      "emailInput": "Campo de entrada de dirección de email",
      "confirmButton": "Confirmar y enviar información del perfil",
      "closeButtonHint": "Cierra este formulario"
    },
    "validation": {
      "firstNameRequired": "El nombre es requerido",
      "firstNameInvalid": "El nombre no puede contener números",
      "lastNameRequired": "El apellido es requerido",
      "lastNameInvalid": "El apellido no puede contener números",
      "phoneRequired": "El número de teléfono es requerido",
      "emailRequired": "La dirección de email es requerida",
      "phoneInvalid": "Por favor ingresa un número de teléfono válido",
      "emailInvalid": "Por favor ingresa una dirección de email válida"
    }
  },
  "AppointmentsScreen": {
    "title": "Citas",
    "upcoming": "PRÓXIMAS",
    "past": "PASADAS",
    "at": "en",
    "barberAtShop": "{{firstName}} {{lastInitial}}. en {{shopName}}",
    "cancelled": "Cancelada",
    "noAppointments": "Todavía no hay citas",
    "error": "No se pudieron cargar las citas. Por favor, inténtalo de nuevo.",
    "tryAgain": "Intentar de nuevo",
    "groupAppointmentCount": "{{count}} citas en {{shop}}",
    "groupInitials": "G",
    "accessibility": {
      "appointmentItem": "Cita el {{date}} con {{barber}} en {{shop}}",
      "groupAppointmentItem": "{{count}} citas en {{shop}}"
    },
    "barberDetailsFormat": "{{firstName}} {{lastNameInitial}}. en {{shopName}}"
  },
  "AppointmentItem": {
    "cancelled": "Cancelada",
    "accessibility": {
      "appointmentItem": "Elemento de cita",
      "groupAppointmentItem": "Elemento de cita grupal"
    }
  },
  "availability": {
    "available": "Disponible\n{{date}}",
    "today": "Hoy",
    "tomorrow": "Mañana",
    "anyProfessional": "Reservar con cualquier\nprofesional"
  },
  "ChooseProfessionalScreen": {
    "title": "Elegir Profesional",
    "accessibility": {
      "closeButton": "Cerrar",
      "closeButtonHint": "Volver a la pantalla anterior"
    }
  },
  "ProfessionalGrid": {
    "anyProfessional": "Elige un servicio primero",
    "availableToday": "Disponible hoy",
    "error": {
      "title": "Algo salió mal",
      "message": "No pudimos cargar los profesionales disponibles. Por favor, inténtalo de nuevo más tarde.",
      "goHome": "Ir al inicio"
    },
    "empty": {
      "title": "No Hay Profesionales Disponibles",
      "message": "Actualmente no hay barberos disponibles en esta ubicación"
    }
  },
  "GiftCard": {
    "title": "Compra una tarjeta de regalo",
    "subtitle": "Regala el cuidado personal"
  },
  "GiftCardAmountScreen": {
    "title": "Tarjeta de Regalo",
    "pleaseSelectAmount": "Por favor, selecciona la cantidad",
    "previewTitle": "Tarjeta regalo",
    "previewSubtitle": "Regala el arte del cuidado personal",
    "previewAccessibilityLabelUnselected": "{{title}}. {{subtitle}}",
    "previewAccessibilityLabelSelected": "{{title}}. {{amount}}",
    "custom": "Personalizado",
    "viewOrder": "Ver Pedido",
    "summary": {
      "label": "Cantidad seleccionada",
      "placeholder": "Ninguna cantidad seleccionada"
    },
    "customAmount": {
      "placeholder": "Ingresa cantidad"
    },
    "processing": "Procesando",
    "tryAgain": "Intentar de nuevo"
  },
  "GiftCardOrderBar": {
    "viewOrder": "Ver Pedido",
    "continueButton": "Continuar",
    "accessibility": {
      "expandHint": "Abre el resumen del pedido",
      "orderSummary": "Tarjeta de regalo {{amount}}. Toca para ver el pedido."
    }
  },
  "GiftCardOrderBottomSheet": {
    "title": "Tu Pedido",
    "giftCardItem": "Tarjeta de Regalo",
    "subtotal": "Subtotal",
    "continueButton": "Continuar",
    "anyProfessional": "Cualquier Profesional",
    "accessibility": {
      "closeBottomSheet": "Cerrar resumen del pedido",
      "closeBottomSheetHint": "Cierra el resumen del pedido"
    }
  },
  "ConfirmGiftCardBottomSheet": {
    "title": "Comprar starjeta de regalo",
    "haveAccount": "¿Tienes una cuenta?",
    "signIn": "Iniciar sesión",
    "buyGiftCard": "Comprar tarjeta de regalo",
    "buyingGiftCard": "Comprando tarjeta de regalo",
    "paymentMethod": "Método de Pago",
    "creditOrDebitCard": "Tarjeta o cuenta bancaria",
    "applePay": "Apple Pay",
    "googlePay": "Google Pay",
    "giftCardSummary": "Tarjeta de Regalo",
    "legalText": "Al continuar, aceptas nuestros",
    "termsOfService": "Términos de Servicio",
    "and": "y",
    "privacyPolicy": "Política de Privacidad",
    "accessibility": {
      "bookButton": "Comprar tarjeta de regalo",
      "bookButtonHint": "Completa tu compra de tarjeta de regalo",
      "paymentMethod": "Método de pago: {{method}}",
      "paymentMethodHint": "Seleccionar {{method}} como pago"
    },
    "userInformation": {
      "title": "Tu Información",
      "firstNamePlaceholder": "Nombre",
      "lastNamePlaceholder": "Apellido",
      "phonePlaceholder": "Número de teléfono",
      "emailPlaceholder": "Correo electrónico",
      "accessibility": {
        "firstNameInput": "Nombre",
        "lastNameInput": "Apellido",
        "phoneInput": "Número de teléfono",
        "phoneInputHint": "Ingresa tu número de teléfono",
        "emailInput": "Correo electrónico"
      },
      "validation": {
        "firstNameRequired": "El nombre es requerido",
        "firstNameInvalid": "El nombre solo debe contener letras",
        "lastNameRequired": "El apellido es requerido",
        "lastNameInvalid": "El apellido solo debe contener letras",
        "phoneInvalid": "Ingresa un número de teléfono válido",
        "emailInvalid": "Ingresa un correo electrónico válido",
        "emailRequired": "El correo electrónico es requerido",
        "paymentMethodRequired": "Selecciona un método de pago"
      }
    },
    "error": {
      "purchaseFailed": "Algo salió mal. Por favor, intenta de nuevo.",
      "paymentError": "El pago falló. Por favor, intenta de nuevo."
    }
  },
  "ViewGiftCardScreen": {
    "title": "Gift Card",
    "thankYouTitle": "Gracias por comprar tu tarjeta de regalo",
    "promotionalHeadline": "Regala el arte de verte bien",
    "promotionalDescription": "A todos nos gusta verse bien, ¡así que regálate este cuidado!",
    "giftCardForShop": "Esta tarjeta de regalo es para {{shopName}}",
    "code": "Código de tarjeta de regalo",
    "totalPrice": "Precio total",
    "anyProfessional": "Cualquier Profesional",
    "giftCardItem": "Tarjeta de Regalo",
    "done": "Listo",
    "copiedToClipboard": "Código copiado al portapapeles",
    "paymentDetails": "Detalles de pago",
    "close": "Cerrar",
    "accessibility": {
      "closeHint": "Cierra la tarjeta de regalo"
    }
  },
  "ProfessionalCard": {
    "anyProfessional": "Elige un servicio primero",
    "bookWithAnyProfessional": "Reservar con cualquier profesional",
    "professionalFallback": "Profesional",
    "giftCard": {
      "title": "Comprar una tarjeta de regalo",
      "subtitle": "Regala el arte del cuidado personal",
      "accessibility": {
        "label": "Comprar una tarjeta de regalo",
        "hint": "Abre la compra de tarjeta de regalo"
      }
    },
    "availability": {
      "available": "Disponible {{date}}",
      "today": "Hoy",
      "tomorrow": "Mañana",
      "notAvailable": "No Disponible"
    },
    "infoIcon": {
      "accessibility": {
        "label": "Ver información del profesional",
        "hint": "Abre detalles y fotos de Instagram"
      }
    },
    "accessibility": {
      "selectAnyProfessional": "Seleccionar cualquier profesional para tu cita",
      "selectProfessional": "Seleccionar {{name}} como tu profesional",
      "selectThisProfessional": "Seleccionar este profesional",
      "currentlySelected": "Actualmente seleccionado. Toca para deseleccionar.",
      "tapToSelect": "Toca para seleccionar este profesional para tu cita."
    }
  },
  "ProfessionalPasscodeBottomSheet": {
    "title": "Ingresar código",
    "subtitle": "Este profesional requiere un código para reservar",
    "unlocked": "Desbloqueado",
    "verifying": "Verificando...",
    "placeholder": "Ingresar código",
    "submit": "Desbloquear",
    "cancel": "Cancelar",
    "error": {
      "invalid": "Código inválido. Por favor, inténtalo de nuevo.",
      "incorrectPassword": "Contraseña incorrecta",
      "network": "Error de red. Por favor, inténtalo de nuevo."
    },
    "accessibility": {
      "input": "Campo de entrada de código",
      "submit": "Enviar código para desbloquear reserva",
      "cancel": "Cancelar entrada de código y regresar"
    }
  },
  "ProfessionalInfoBottomSheet": {
    "title": "{{name}}",
    "viewOnInstagram": "Ver más en Instagram",
    "accessibility": {
      "close": "Cerrar información del profesional",
      "instagramImage": "Foto de Instagram {{index}} de {{total}}",
      "closeHint": "Cierra los detalles del profesional"
    }
  },
  "ProfessionalInstagramGallery": {
    "counter": "{{current}} / {{total}}",
    "accessibility": {
      "back": "Volver a la cuadrícula de fotos",
      "image": "Foto de Instagram {{index}}",
      "thumbnail": "Ver foto de Instagram {{index}}"
    }
  },
  "ChooseServiceCategoryScreen": {
    "title": "Elegir Servicio",
    "empty": {
      "message": "No hay servicios disponibles para reservar en este momento"
    }
  },
  "ChooseServiceSubcategoryScreen": {
    "title": "Elegir Servicio",
    "empty": {
      "message": "No hay servicios disponibles para reservar en este momento"
    }
  },
  "CategoryUnavailable": {
    "title": "Esta categoría no está disponible",
    "description": "No encontramos servicios aquí por ahora. Prueba con otra opción.",
    "backToCategories": "Volver a las categorías",
    "backToSubcategories": "Volver a las subcategorías"
  },
  "ChooseServiceScreen": {
    "title": "Elegir Servicio",
    "categoryHeading": "Servicios de {{name}}",
    "ok": "OK",
    "cartCreationFailed": "Error al Crear Carrito",
    "cartCreationError": "No se pudo crear el carrito: {{message}}. Por favor, inténtalo de nuevo.",
    "loading": {
      "servicesText": "Cargando servicios...",
      "findingServicesFor": "Buscando servicios para",
      "anyProfessional": "cualquier profesional"
    },
    "error": {
      "title": "No se pueden cargar los servicios",
      "message": "Hubo un problema al cargar los servicios. Por favor, inténtalo de nuevo más tarde.",
      "tryAgain": "Intentar de nuevo"
    },
    "accessibility": {
      "closeButton": "Cerrar selección de servicio",
      "closeButtonHint": "Cierra la pantalla de selección de servicio y regresa a la pantalla anterior"
    }
  },
  "CategorySelect": {
    "placeholder": "Seleccionar Categoría",
    "all": "Todas las categorías",
    "uncategorized": "Sin categoría"
  },
  "ServiceCategoryBreadcrumb": {
    "anyProfessional": "Cualquiera"
  },
  "ServiceCategoryRow": {
    "servicesCount_one": "{{count}} servicio",
    "servicesCount_other": "{{count}} servicios"
  },
  "ServiceGrid": {
    "additionalServicesTitle": "¿Algo que desees agregar?",
    "yourServicesTitle": "Tus servicios",
    "yourAddonsTitle": "Tus complementos",
    "otherServicesTitle": "Otros servicios",
    "error": {
      "title": "No se pueden cargar los servicios",
      "message": "Hubo un problema al cargar los servicios. Por favor, inténtalo de nuevo más tarde."
    },
    "empty": {
      "filtered": {
        "title": "No hay servicios en esta categoría",
        "message": "Intenta seleccionar una categoría diferente o \"Todas\" para ver más servicios."
      },
      "unfiltered": {
        "title": "No hay servicios disponibles",
        "message": "Actualmente no hay servicios disponibles en esta ubicación."
      }
    },
    "categoryFilterPlaceholder": "Filtrar por categoría",
    "addonCategoryLabel": "Complementos"
  },
  "ViewOrderBar": {
    "viewOrder": "Ver Pedido",
    "goToCheckout": "Ir al pago",
    "itemCount": {
      "one": "1 artículo",
      "other": "{{count}} artículos"
    },
    "accessibility": {
      "expandHint": "Toca para expandir los detalles del pedido",
      "orderSummary": "Resumen del pedido: {{itemCount}}, {{totalPrice}}"
    },
    "continue": "Continuar"
  },
  "ViewOrderCartPromo": {
    "saving": "Ahorrando {{amount}} con promoción",
    "useBy": "Usar antes del {{date}}"
  },
  "ViewOrderDepositCard": {
    "title": "Depósito a pagar hoy",
    "refundable": "Reserva tu cita. Se aplica a tu servicio y es reembolsable.",
    "nonRefundable": "Reserva tu cita. Se aplica a tu servicio. No reembolsable."
  },
  "ViewOrderBottomSheet": {
    "depositDueToday": "Depósito a pagar hoy",
    "title": "Tu Pedido",
    "shopNamePlaceholder": "Barbería",
    "anyProfessional": "Cualquier Profesional",
    "addGuest": "Agregar invitado al pedido",
    "checkoutAllAtOnce": "Pagar todo de una vez",
    "groupOrderLimitReached": "Límite de pedido grupal alcanzado",
    "groupOrderLimitDescription": "Puedes agregar hasta 5 citas",
    "subtotal": "Subtotal",
    "chooseTime": "Elegir horario",
    "nextAvailableTime": "Próximo horario disponible",
    "addButton": "Agregar",
    "tip": "Propina",
    "tipTooltip": "Propina preliminar para tu profesional.\nPuede ajustarse después de la cita, reflejando tu experiencia general.",
    "tipTooltipGroup": "Propina preliminar para tu profesional.\nLa propina para el mismo profesional solo puede aplicarse una vez.",
    "guestAppointment": "Cita de invitado",
    "waitlistMeFor": "Agrégame a la lista de espera para el {{date}}",
    "joinWaitlistFor": "Únete a la lista de espera para el {{date}}",
    "preferredTime": "Horario preferido",
    "accessibility": {
      "closeOrderSummary": "Cerrar resumen del pedido",
      "closeOrderSummaryHint": "Toca para cerrar el resumen del pedido",
      "addGuestButton": "Agregar invitado a la cita grupal",
      "editOrder": "Editar pedido"
    }
  },
  "EditOrderBottomSheet": {
    "title": "Editar pedido",
    "done": "Listo",
    "location": "Ubicación",
    "professional": "Profesional",
    "services": "Servicios",
    "dateTime": "Fecha y hora",
    "anyProfessional": "Cualquier Profesional",
    "guestAppointment": "Cita de invitado",
    "accessibility": {
      "editLocation": "Editar ubicación",
      "editProfessional": "Editar profesional",
      "editServices": "Editar servicios",
      "editTime": "Editar fecha y hora",
      "removeAddon": "Quitar {{name}}"
    }
  },
  "PriceRangeTooltip": {
    "content": "Los profesionales fijan sus propios precios, por lo que este es el rango en todo el equipo. Elige un profesional para ver su precio exacto.",
    "accessibilityLabel": "Información del rango de precios"
  },
  "ServiceCard": {
    "giftCard": {
      "title": "Tarjeta de regalo",
      "fromPrice": "desde {{price}}",
      "accessibility": {
        "label": "Tarjeta de regalo, {{fromPrice}}",
        "hint": "Abre la compra de tarjeta de regalo"
      }
    },
    "duration": {
      "minutes": "min",
      "hours": "h",
      "minutesShort": "m"
    },
    "action": {
      "addService": "Agregar servicio",
      "removeService": "Quitar servicio"
    },
    "badge": {
      "addon": "Complemento"
    },
    "description": {
      "moreDetails": "Más detalles",
      "lessDetails": "Menos detalles"
    },
    "accessibility": {
      "serviceInformation": "Información del servicio",
      "hideDescription": "Ocultar descripción del servicio",
      "showDescription": "Mostrar descripción del servicio",
      "serviceDetails": "Servicio: {{name}}, Duración: {{duration}}, Precio: {{price}}",
      "currentlySelected": "Servicio actualmente seleccionado",
      "tapToSelect": "Toca para seleccionar este servicio"
    }
  },
  "ChooseTimeGuestSection": {
    "anyProfessional": "Cualquier profesional",
    "noAvailableTimes": "No hay horarios disponibles",
    "noTimesAvailable": "No hay horarios disponibles",
    "oneTimeAvailable": "1 horario disponible",
    "suggestedForYou": "Sugerido para ti",
    "timesAvailable": "{{count}} horarios disponibles",
    "duration": {
      "hours": "hr",
      "hoursPlural": "hrs",
      "minutes": "min"
    }
  },
  "ViewOrderBottomSheetActions": {
    "accessibility": {
      "chooseTimeButton": "Botón elegir horario",
      "chooseTimeButtonHint": "Toca para elegir un horario",
      "nextAvailableTimeButton": "Botón próximo horario disponible",
      "nextAvailableTimeButtonHint": "Toca para elegir el próximo horario disponible",
      "continueButton": "Botón continuar",
      "continueButtonHint": "Toca para continuar"
    },
    "continue": "Continuar",
    "waitlistDisclaimer": "Se requiere una tarjeta en el archivo para ser incluido en la lista de espera. Los cargos aplican solo si aceptas una reserva."
  },
  "TimeSlotButton": {
    "accessibility": {
      "tapToSelect": "Toca para seleccionar este horario",
      "notAvailable": "Este horario no está disponible"
    }
  },
  "ChooseTimeSlotGrid": {
    "showAll": "Mostrar todos",
    "showLess": "Mostrar menos",
    "accessibility": {
      "showAllTimes": "Mostrar todos los horarios",
      "showLessTimes": "Mostrar menos horarios"
    }
  },
  "ChooseTimeCalendarDay": {
    "accessibility": {
      "notAvailable": "No disponible",
      "noTimesAvailable": "No hay horarios disponibles",
      "oneTime": "1 horario",
      "multipleTimes": "{{count}} horarios",
      "available": "disponibles",
      "tapToSelect": "Toca para seleccionar esta fecha"
    }
  },
  "ChooseTimeEmptyState": {
    "nextTime": "Próximo horario",
    "noAvailability": "Sin disponibilidad",
    "waitlist": "Lista de espera"
  },
  "WaitlistTimePreferencePicker": {
    "title": "¿Qué horario prefieres?",
    "anytime": "Cualquier hora",
    "morning": "Mañana",
    "afternoon": "Tarde",
    "evening": "Noche",
    "afterHours": "Fuera de horario",
    "range": {
      "morning": "9:00am - 12:00pm",
      "afternoon": "12:00pm - 5:00pm",
      "evening": "5:00pm - 8:00pm",
      "afterHours": "desde las 8:00pm"
    },
    "accessibility": {
      "anytime": "Cualquier hora",
      "morning": "Mañana, de 9:00am a 12:00pm",
      "afternoon": "Tarde, de 12:00pm a 5:00pm",
      "evening": "Noche, de 5:00pm a 8:00pm",
      "afterHours": "Fuera de horario, desde las 8:00pm",
      "rowHint": "Agrega o quita este horario de tu preferencia en la lista de espera",
      "anytimeHint": "Quita los demás horarios para que cualquier hora sirva"
    }
  },
  "StandbyWaitlistJoinSheet": {
    "title": "Únete a la lista de espera",
    "cta": "Ponme en la lista de espera",
    "legalIntro": "Al unirte a la lista de espera, aceptas los",
    "summary": {
      "title": "Resumen",
      "joinWaitlistFor": "Únete a la lista de espera para",
      "preferredTime": "Horario preferido",
      "professional": "Profesional",
      "anyProfessional": "Cualquier profesional",
      "duration": "Duración",
      "total": "Total"
    },
    "accessibility": {
      "ctaHint": "Te agrega a la lista de espera de este día"
    }
  },
  "ChooseTimeLoadingScreen": {
    "title": "Elegir horario"
  },
  "ChooseTimeScreen": {
    "title": "Elegir horario",
    "processing": "Procesando",
    "ok": "OK",
    "preselectDateOutsideWindow": "Esa fecha está fuera de la ventana de reserva en línea, así que no pudimos seleccionarla por vos",
    "error": {
      "title": "Error",
      "paymentError": "Algo salió mal con el pago",
      "bookingPaymentError": "Ocurrió un error al procesar el pago de la reserva. Por favor, inténtalo de nuevo.",
      "alreadyOnWaitlist": "Ya estás en la lista de espera",
      "throttled": "Demasiados intentos. Espera un momento e inténtalo de nuevo.",
      "standbyWaitlistUnavailable": "Esta lista de espera no está disponible en este momento.",
      "standbyAlreadyOnWaitlist": "Ya estás en la lista de espera",
      "paymentRequiredForWaitlist": "Se requiere un método de pago para unirse a esta lista de espera",
      "digitalWalletNotAvailable": "El método de pago de billetera digital no está disponible",
      "digitalWalletPaymentFailed": "El pago falló",
      "digitalWalletUnexpectedError": "Ocurrió un error inesperado",
      "cartExpired": "Tu sesión de reserva ha expirado. Por favor, comienza tu reserva de nuevo.",
      "startOver": "Empezar de nuevo",
      "timeoutTitle": "Se agotó el tiempo de espera",
      "timeoutMessage": "Es posible que tu reserva se haya completado. Revisa tus próximas citas antes de volver a intentarlo.",
      "networkTitle": "Se perdió la conexión",
      "networkMessage": "Comprueba tu conexión a internet e inténtalo de nuevo.",
      "paymentFailedTitle": "El pago falló",
      "paymentFailedMessage": "No se pudo procesar tu pago. Prueba con otro método de pago.",
      "serverErrorTitle": "Algo salió mal",
      "serverErrorMessage": "Ocurrió un error inesperado. Inténtalo de nuevo más tarde.",
      "deepLinkUnavailableTitle": "No disponible",
      "deepLinkUnavailableMessage": "Este servicio no está disponible para reservar en línea en este momento.",
      "goBack": "Volver"
    }
  },
  "Calendar": {
    "today": "Hoy",
    "accessibility": {
      "previousMonth": "Mes anterior",
      "nextMonth": "Mes siguiente"
    }
  },
  "CalendarDay": {
    "accessibility": {
      "today": "Hoy",
      "selected": "Seleccionado",
      "notAvailable": "No disponible",
      "tapToSelect": "Toca para seleccionar esta fecha"
    }
  },
  "TipSelector": {
    "none": "Ninguna",
    "other": "Otra",
    "dollarSign": "$",
    "accessibility": {
      "enterCustomTip": "Ingresa el monto de propina personalizada en dólares",
      "enterCustomTipHint": "Ingresa un monto de propina personalizada. Valor actual: {{value}}",
      "dollarSign": "Signo de dólar",
      "confirmButton": "Confirmar monto de propina{{amount}}",
      "confirmButtonHint": "{{hasAmount}}",
      "confirmButtonHintWithAmount": "Confirmar el monto de propina de ${{amount}}",
      "confirmButtonHintEmpty": "Ingresa un monto de propina primero, luego confirma",
      "confirm": "Confirmar",
      "tipSelectionOptions": "Opciones de selección de propina",
      "tipSelectionHint": "Selecciona un monto de propina para tu servicio",
      "noTip": "Sin propina",
      "noTipHint": "Selecciona para no dar propina",
      "percentageTip": "{{percentage}}% de propina",
      "percentageTipHint": "Selecciona {{percentage}}% de propina por un monto de ${{amount}}",
      "customTip": "Propina personalizada de ${{amount}}",
      "customTipAmount": "Monto de propina personalizada",
      "customTipSelected": "Monto de propina personalizada actualmente seleccionado",
      "customTipSelect": "Selecciona para ingresar un monto de propina personalizada"
    },
    "custom": "Personalizado"
  },
  "AdultOnlyConsent": {
    "title": "21 años o más",
    "ageRestriction": "21+",
    "descriptionPrefix": "Al reservar una cita, aceptas que",
    "descriptionSuffix": "tienes 21 años o más.",
    "agree": "Estoy de acuerdo"
  },
  "CancellationPolicy": {
    "title": "Política de cancelación",
    "cannotCancelDescription": "Según la política de cancelación, no puedes cancelar esta cita.",
    "cannotCancelDescriptionGiftCard": "Según la política de cancelación, no puedes cancelar este pedido.",
    "freeCancellation": "Cancelación gratuita hasta las {{time}} del {{date}}"
  },
  "CancellationPolicyConsent": {
    "title": "Política de cancelación",
    "description": "Tendrás tiempo hasta <strong>{{time}}</strong> el <strong>{{date}}</strong> para cancelar esta cita sin ser cargado.",
    "now": "AHORA",
    "understand": "Estoy de acuerdo"
  },
  "NotificationConsent": {
    "accessibility": {
      "sms": {
        "yes": "Sí, recibir mensajes de texto promocionales",
        "skip": "Omitir, no recibir mensajes de texto"
      },
      "email": {
        "yes": "Sí, recibir correos electrónicos promocionales",
        "skip": "Omitir, no recibir correos electrónicos"
      }
    },
    "title": "{{name}} quiere mantenerse en contacto!",
    "yes": "Sí",
    "skip": "Omitir",
    "sms": {
      "description": "Al hacer clic en \"Sí\" abajo, aceptas recibir mensajes de texto promocionales automatizados en el número de teléfono que proporciones.",
      "descriptionTerms": "El consentimiento no es una condición de compra. Texto HELP para ayuda y STOP para cancelar. Las tarifas de mensajes y datos pueden aplicarse y la tarifa de mensajes varía. No todos los operadores están cubiertos. Ver <modalLink>Términos y Privacidad</modalLink> para más información."
    },
    "email": {
      "description": "Al hacer clic en \"Sí\" abajo, aceptas recibir correos electrónicos promocionales en la dirección de correo electrónico que proporciones.",
      "descriptionTerms": "El consentimiento no es una condición de compra. Puedes cancelar la suscripción en cualquier momento usando el enlace en cualquier correo electrónico. Ver <modalLink>Términos y Privacidad</modalLink> para más información."
    }
  },
  "AppStoreReviewPrompt": {
    "title": "¿Qué te parece la aplicación hasta ahora?",
    "description": "Ya sea que nos ames o tengas comentarios, ¡queremos saberlo!",
    "primaryButton": "¡Me encanta!",
    "secondaryButton": "Necesita trabajo",
    "accessibility": {
      "closeButton": "Cerrar el aviso de reseña",
      "closeButtonHint": "Cierra este aviso de reseña"
    }
  },
  "NPSSurveyModal": {
    "title": "Pregunta rápida",
    "question": "¿Qué tan probable es que recomiendes SQUIRE a tus amigos y colegas?",
    "fromNotLikely": "De poco probable",
    "toMostLikely": "a muy probable",
    "maybeLater": "Quizás después",
    "done": "Listo",
    "sendFeedback": "Enviar comentario",
    "thankYouTitle": "¡Gracias!",
    "anythingElse": "¿Algo más que quieras agregar?",
    "thankYouBody": "Tus comentarios se usarán para mejorar nuestros servicios",
    "reasonLabel": "RAZÓN DE TU PUNTUACIÓN",
    "reasonPlaceholder": "Escribe tu comentario",
    "thankYouToast": "¡Gracias por tu tiempo!",
    "submitError": "Error al enviar. Por favor, inténtalo de nuevo."
  },
  "TermsWebViewModal": {
    "title": "Términos de servicio",
    "accessibility": {
      "closeButton": "Cerrar términos",
      "closeButtonHint": "Cierra los términos y condiciones"
    }
  },
  "TermsScreen": {
    "title": "Términos de servicio",
    "loading": "Cargando términos...",
    "error": "Error al cargar los términos de servicio"
  },
  "PrivacyScreen": {
    "title": "Política de privacidad",
    "loading": "Cargando política de privacidad...",
    "error": "Error al cargar la política de privacidad"
  },
  "WebViewScreen": {
    "errorTitle": "Error al cargar contenido",
    "errorMessage": "Por favor, verifica tu conexión a internet e intenta de nuevo.",
    "accessibility": {
      "loadingContent": "Cargando contenido",
      "closeButton": "Cerrar",
      "closeButtonHint": "Cierra la pantalla y regresa a la página anterior"
    }
  },
  "ProfileScreen": {
    "editProfile": "Editar Perfil",
    "phoneNotProvided": "Número de teléfono no configurado",
    "editPhoneNumber": "Editar número de teléfono",
    "setPhoneNumber": "Configurar número de teléfono",
    "editEmail": "Editar correo electrónico",
    "changePassword": "Cambiar contraseña",
    "notifications": "Notificaciones",
    "confirm": "Confirmar",
    "reschedule": "Reprogramar",
    "cancel": "Cancelar",
    "deleteAccount": "Eliminar cuenta",
    "firstName": "Nombre",
    "lastName": "Apellido",
    "saveChanges": "Guardar",
    "editFirstName": "Toca para editar el nombre",
    "editLastName": "Toca para editar el apellido",
    "nameSaved": "Nombre actualizado exitosamente",
    "nameUpdateFailed": "Error al actualizar el nombre",
    "error": "No se pudo cargar el perfil",
    "tryAgain": "Intentar de nuevo",
    "editPhoto": {
      "uploadError": {
        "title": "No se pudo actualizar la foto",
        "message": "Algo salió mal al subir tu foto. Por favor intenta de nuevo."
      }
    },
    "accessibility": {
      "profileInfo": "Sección de información del perfil",
      "editPhoto": "Editar foto de perfil",
      "editPhoneNumberButton": "Editar número de teléfono",
      "setPhoneNumberButton": "Configurar número de teléfono",
      "editEmailButton": "Editar correo electrónico",
      "changePasswordButton": "Cambiar contraseña",
      "notificationsButton": "Configuración de notificaciones",
      "deleteAccountButton": "Eliminar cuenta",
      "deleteAccountButtonHint": "Eliminar permanentemente tu cuenta",
      "firstNameEdit": "Editar nombre",
      "lastNameEdit": "Editar apellido",
      "saveNameButton": "Guardar cambios de nombre",
      "saveChanges": "Guardar cambios",
      "saveChangesHint": "Guardar el nombre editado"
    }
  },
  "AppointmentDetailMap": {
    "accessibility": {
      "closeButton": "Cerrar detalles de la cita"
    }
  },
  "AppointmentDetailShopInfo": {
    "appointmentCancelled": "Cita cancelada",
    "getDirections": "Obtener direcciones",
    "accessibility": {
      "getDirections": "Obtener direcciones a la tienda"
    }
  },
  "AppointmentDetailInfo": {
    "cancelled": "Cancelada",
    "confirmationCode": "Código de confirmación",
    "professional": "Profesional",
    "professionalNoLongerAvailable": "Ya no está disponible",
    "service": "Servicio",
    "time": "Hora",
    "tip": "Propina",
    "addTip": "Agregar propina",
    "addToCalendar": "Agregar al calendario",
    "rateYourAppointment": "Califica tu cita",
    "youRatedStars": "Calificaste {{count}} estrellas",
    "calendarTitle": {
      "withShop": "{{serviceName}} en {{shopName}}",
      "withProfessional": "{{serviceName}} con {{professionalName}}"
    },
    "calendarDescription": {
      "confirmationCode": "Código de confirmación: {{confirmationCode}}",
      "professional": "Profesional: {{professionalName}}",
      "service": "Servicio: {{serviceName}}",
      "location": "Ubicación: {{shopName}}"
    },
    "accessibility": {
      "addToCalendar": "Agregar cita al calendario",
      "addTip": "Agregar propina para esta cita",
      "changeTip": "Cambiar monto de propina",
      "rateAppointmentButton": "Califica tu cita",
      "rateAppointmentButtonHint": "Toca para calificar esta cita",
      "ratingDisplay": "Calificaste esta cita con {{count}} estrellas",
      "starIcon": "Estrella {{position}} de {{total}}"
    }
  },
  "AppointmentRatingPromptModal": {
    "successMessage": "¡Gracias por tu opinión!",
    "loadError": "No se pudieron cargar los datos de la cita. Por favor, inténtalo de nuevo.",
    "accessibility": {
      "closeButton": "Cerrar el aviso de calificación",
      "closeButtonHint": "Cierra este aviso de calificación"
    }
  },
  "AppointmentRatingScreen": {
    "title": "Califica tu cita",
    "successMessage": "¡Gracias por tu opinión!",
    "error": "No se pudieron cargar los datos de la cita. Por favor, inténtalo de nuevo.",
    "tryAgain": "Intentar de nuevo",
    "step1": {
      "heading": "¿Cómo fue tu experiencia con {{firstName}}?",
      "nextButton": "Siguiente"
    },
    "step2": {
      "heading": "¡Gracias por calificar! ¿Algo más que quieras compartir?",
      "inputPlaceholder": "Considera compartir detalles sobre habilidad, puntualidad, etc.",
      "skipButton": "Omitir",
      "submitButton": "Enviar reseña"
    },
    "accessibility": {
      "closeButton": "Cerrar pantalla de calificación",
      "closeButtonHint": "Cancelar y volver a los detalles de la cita",
      "nextButton": "Continuar al paso de reseña",
      "nextButtonHint": "Proceder a agregar una reseña opcional",
      "skipButton": "Omitir reseña y enviar calificación",
      "skipButtonHint": "Enviar calificación sin reseña",
      "submitButton": "Enviar calificación con reseña",
      "submitButtonHint": "Enviar tu calificación de {{count}} estrellas y reseña",
      "starButton": "Calificar {{count}} estrellas",
      "starButtonHint": "Seleccionar calificación de {{count}} estrellas"
    }
  },
  "AppointmentDetailSummary": {
    "subtotal": "Subtotal",
    "services": "Servicios",
    "taxesAndFees": "Impuestos y tarifas",
    "tax": "Impuesto",
    "fee": "Tarifa",
    "tip": "Propina",
    "total": "Total",
    "addTip": "Agregar propina",
    "changeTip": "Cambiar",
    "addCode": "Agregar código",
    "promo": "Promoción",
    "membership": "Membresía",
    "giftCard": "Tarjeta de regalo",
    "accessibility": {
      "addTip": "Agregar propina a tu cita",
      "changeTip": "Cambiar monto de propina",
      "addCode": "Agregar código promocional",
      "removePromo": "Eliminar código promocional",
      "expandTaxes": "Expandir desglose de impuestos y tarifas",
      "collapseTaxes": "Contraer desglose de impuestos y tarifas"
    }
  },
  "AppointmentDetailPayment": {
    "chargeDisclaimer": "No se te cobrará hasta una hora antes de que comience tu cita."
  },
  "AppointmentDetailActions": {
    "reschedule": "Reprogramar",
    "cancel": "Cancelar",
    "rebook": "Reservar de nuevo",
    "rebooking": "Reservando...",
    "rebookError": "No se puede reservar la cita de nuevo",
    "rebookErrorDescription": "Este pedido no se puede reservar de nuevo en este momento.",
    "barberUnavailable": "Tu barbero ya no está disponible. Elige uno nuevo.",
    "serviceUnavailable": "El servicio reservado ya no está disponible. Elige uno nuevo.",
    "accessibility": {
      "reschedule": "Reprogramar cita",
      "cancel": "Cancelar cita",
      "rebook": "Reservar cita de nuevo",
      "rebooking": "Reservando..."
    }
  },
  "TipSelectionModal": {
    "title": "Cambiar propina",
    "none": "Ninguna",
    "other": "Otra",
    "confirm": "Confirmar",
    "dollarSign": "$",
    "accessibility": {
      "close": "Cerrar modal de selección de propina",
      "tipPercentage": "{{percentage}}% de propina",
      "noTip": "Sin propina",
      "customTip": "Monto de propina personalizada",
      "confirm": "Confirmar selección de propina",
      "dollarSign": "Signo de dólar",
      "enterCustomTipHint": "Ingresa un monto de propina personalizada. Valor actual: {{value}}",
      "confirmCustomTip": "Confirmar monto de propina personalizada",
      "closeHint": "Cierra este diálogo"
    }
  },
  "CalendarSelectionModal": {
    "title": "Agregar al calendario",
    "googleCalendar": "Google Calendar",
    "appleCalendar": "Apple iCalendar",
    "accessibility": {
      "close": "Cerrar modal de selección de calendario",
      "googleCalendar": "Agregar cita a Google Calendar",
      "appleCalendar": "Agregar cita a Apple Calendar",
      "closeHint": "Cierra este diálogo"
    }
  },
  "PromoCodeModal": {
    "title": "Agregar código",
    "codeLabel": "CÓDIGO",
    "codePlaceholder": "Ingresa tu código",
    "apply": "Aplicar",
    "accessibility": {
      "close": "Cerrar modal de código promocional",
      "codeInput": "Campo de código promocional",
      "codeInputHint": "Ingresa tu código promocional",
      "apply": "Aplicar código promocional"
    }
  },
  "AppointmentDetailScreen": {
    "title": "Detalles de la Cita",
    "orderInfo": "Información del pedido",
    "professionalNoLongerAvailable": "Ya no está disponible",
    "error": "Error al cargar los detalles de la cita. Por favor, inténtalo de nuevo.",
    "tryAgain": "Intentar de nuevo",
    "accessibility": {
      "closeButton": "Cerrar detalles de la cita",
      "closeButtonHint": "Volver a la lista de citas"
    }
  },
  "ViewReservationContentWrapper": {
    "confirmation": {
      "title": "{{name}}, tu cita está confirmada.",
      "titleGeneric": "Tu cita está confirmada.",
      "orderTitle": "{{name}}, tu pedido está confirmado.",
      "orderTitleGeneric": "Tu pedido está confirmado."
    },
    "canceled": {
      "title": "Cita cancelada",
      "orderTitle": "Pedido cancelado"
    },
    "totalPrice": "Precio total",
    "taxes": "Impuestos",
    "fee": "Tarifa",
    "giftCard": "Tarjeta de regalo",
    "promo": "Promoción",
    "membership": "Membresía",
    "addToCalendar": "Agregar al calendario",
    "appleCalendar": "iCalendar",
    "googleCalendar": "Google",
    "yahooCalendar": "Yahoo",
    "actions": {
      "reschedule": "Reprogramar cita",
      "cancel": "Cancelar cita",
      "scheduleAnother": "Programar otra cita"
    },
    "accessibility": {
      "close": "Cerrar",
      "appleCalendar": "Agregar a Apple Calendar",
      "googleCalendar": "Agregar a Google Calendar",
      "yahooCalendar": "Agregar a Yahoo Calendar",
      "closeHint": "Cierra los detalles de la reserva"
    }
  },
  "ViewReservationAppointmentCard": {
    "confirmationCode": "Código de confirmación",
    "duration": {
      "label": "Duración",
      "hours": "h",
      "minutes": "min",
      "minutesShort": "m"
    },
    "time": "Hora",
    "tip": "Propina",
    "accessibility": {
      "rescheduleAppointment": "Reprogramar cita"
    }
  },
  "ViewReservationPaymentStatus": {
    "pay": "Pagar",
    "applePay": "Apple Pay",
    "creditCard": "Tarjeta de crédito",
    "giftCard": "Tarjeta de regalo",
    "payInPerson": "Pagar en persona",
    "pending": "PAGO PENDIENTE",
    "canceled": "CANCELADO",
    "paid": "PAGADO",
    "disclaimer": "No se te cobrará hasta una hora antes de que comience tu cita.",
    "canceledNotCharged": "No se te cobró debido a la cancelación de esta cita.",
    "canceledCharged": "Se te cobró a pesar de cancelar la cita debido a la Política de Cancelación de {{shopName}}."
  },
  "ViewReservationErrorFallback": {
    "title": "Error al cargar la reserva",
    "retry": "Intentar de nuevo",
    "takeMeHome": "Llévame al inicio"
  },
  "ViewReservationShopInfo": {
    "getDirections": "Obtener direcciones",
    "accessibility": {
      "getDirections": "Obtener direcciones a la tienda",
      "mapPreview": "Vista previa del mapa de la ubicación de la tienda"
    }
  },
  "ViewWaitlistContentWrapper": {
    "confirmation": {
      "title": "{{name}}, lista de espera confirmada!",
      "titleGeneric": "Lista de espera confirmada!"
    },
    "header": {
      "available": "Un turno está disponible con {{barber}} para {{date}}",
      "expired": "La lista de espera de {{barber}} para {{date}} expiró",
      "removed": "Has sido eliminado de la lista de espera",
      "readyToBook": "La cita con {{barber}} para {{date}} está lista para reservar"
    },
    "badge": {
      "waitingList": "Lista de espera",
      "slotsAvailable": "{{count}} turnos disponibles",
      "expired": "Lista de espera expirada",
      "chooseTime": "Elegir un horario",
      "chooseDifferentTime": "Elegir otra fecha y horario"
    },
    "position": {
      "title": "Estás en la posición {{position}}",
      "subtitle": "en la lista de espera de {{name}}",
      "notify": "Te notificaremos cuando se abra un espacio"
    },
    "actions": {
      "book": "Reservar",
      "reschedule": "Reprogramar",
      "leaveWaitlist": "Salir de la lista de espera"
    },
    "accessibility": {
      "close": "Cerrar",
      "closeHint": "Cierra los detalles de la lista de espera"
    },
    "errors": {
      "bookingFailed": "Error al reservar la cita. Por favor, intenta de nuevo.",
      "rescheduleFailed": "Error al reprogramar. Por favor, intenta de nuevo.",
      "slotsFetchFailed": "Error al cargar los horarios disponibles. Por favor, intenta de nuevo."
    }
  },
  "LeaveWaitlistModal": {
    "title": "¿Salir de la lista de espera?",
    "message": "Perderás tu lugar en la lista de espera. Puedes volver a unirte en cualquier momento.",
    "leave": "Salir de la lista de espera",
    "leaving": "Saliendo...",
    "keep": "Mantener mi lugar",
    "accessibility": {
      "close": "Cerrar",
      "leave": "Salir de la lista de espera",
      "keep": "Mantener mi lugar",
      "closeHint": "Cierra este diálogo"
    },
    "errors": {
      "leaveFailed": "No se pudo salir de la lista de espera. Por favor, intenta de nuevo."
    }
  },
  "ViewWaitlistCard": {
    "duration": "Duración",
    "durationValue": "{{minutes}} min",
    "date": "Fecha",
    "time": "Horario",
    "tip": "Propina",
    "total": "Precio total",
    "chooseTime": "Elegir un horario",
    "chooseDifferentTime": "Elegir otra fecha y horario"
  },
  "WaitlistTimeSlotsSheet": {
    "title": "Horarios disponibles para {{date}}",
    "confirm": "Confirmar"
  },
  "WaitlistRescheduleSheet": {
    "title": "Elegir otra fecha y horario",
    "confirm": "Confirmar"
  },
  "WaitlistRescheduleScreen": {
    "title": "Elige un horario",
    "rescheduleButton": "Confirmar",
    "successMessage": "Reprogramado exitosamente",
    "errorMessage": "Error al reprogramar. Por favor, intente nuevamente.",
    "noTimeSelected": "Por favor, seleccione un horario"
  },
  "EditPhoneNumberBottomSheet": {
    "editTitle": "Editar número de teléfono",
    "setTitle": "Establecer número de teléfono",
    "phoneLabel": "TELÉFONO",
    "phonePlaceholder": "Ingresa tu número de teléfono",
    "sendCodeButton": "Enviar código",
    "verifyTitle": "Verifica tu número de teléfono",
    "verifyDescription": "Hemos enviado un código de verificación de 6 dígitos al teléfono terminado en {{last4}}",
    "sendingCode": "Enviando código de verificación...",
    "codeSent": "Código enviado",
    "validCode": "Código verificado",
    "invalidCode": "Código de verificación inválido. Por favor, intenta de nuevo.",
    "sendCodeError": "Error al enviar código de verificación",
    "sendCodeErrorDescription": "Por favor, intenta de nuevo o contacta a soporte si el problema persiste.",
    "enterCodeLabel": "INGRESA EL CÓDIGO",
    "resendCodeButton": "Reenviar el código",
    "otpCode": "Código",
    "didNotReceiveText": "¿No recibiste nada? Inténtalo de nuevo.",
    "accessibility": {
      "phoneInput": "Entrada de número de teléfono",
      "phoneInputHint": "Ingresa tu número de teléfono",
      "sendCodeButton": "Enviar código",
      "sendCodeButtonHint": "Enviar un código de verificación de 6 dígitos a tu teléfono",
      "saveButtonHint": "Guardar cambios en tu número de teléfono",
      "otpInput": "Entrada de código de verificación",
      "otpInputHint": "Ingresa el código de verificación de 6 dígitos",
      "resendButton": "Reenviar código de verificación",
      "resendButtonHint": "Reenviar el código de verificación a tu teléfono"
    }
  },
  "CancelOrderModal": {
    "title": "Cancelar pedido",
    "message": "¿Estás seguro de que quieres cancelar este pedido? Ten en cuenta que esto cancelará todas las citas asociadas.",
    "cancel": "Cancelar",
    "canceling": "Cancelando...",
    "keep": "Mantener",
    "accessibility": {
      "close": "Cerrar modal de cancelar pedido",
      "cancel": "Cancelar pedido",
      "keep": "Mantener pedido",
      "closeHint": "Cierra este diálogo"
    }
  },
  "ConfirmBookingBottomSheet": {
    "title": "Confirmar reserva",
    "haveAccount": "¿Tienes una cuenta?",
    "signIn": "Iniciar sesión",
    "paymentMethod": "Método de pago",
    "applePay": "Apple Pay",
    "googlePay": "Google Pay",
    "creditOrDebitCard": "Tarjeta o cuenta bancaria",
    "payInPerson": "Pagar en persona",
    "cashApp": "Cash App",
    "buyNowPayLaterWith": "Compra ahora, paga después con {{provider}}",
    "bnplProvider": {
      "klarna": "Klarna",
      "affirm": "Affirm",
      "afterpay_clearpay": "Afterpay"
    },
    "payNow": "Paga ahora",
    "payLater": "Paga después",
    "afterpay": "Afterpay",
    "summary": "Resumen",
    "services": "Servicios",
    "tips": "Propinas",
    "taxes": "Impuestos & Tarifas",
    "total": "Total",
    "addPromoCode": "Agregar un código",
    "promoCode": "Código promocional",
    "giftCard": "Tarjeta de regalo",
    "membership": "Membresía",
    "taxesLabel": "Impuestos",
    "feesLabel": "Tarifas",
    "feesDescription": "Esta es una tarifa de conveniencia que es recaudada por SQUIRE. El monto varía según los servicios en tu carrito.",
    "feesDescriptionWithBarbershop": "Esta es una tarifa de conveniencia recaudada por SQUIRE y tu barbería.",
    "waitlistFeeLabel": "Tarifa de lista de espera",
    "waitlistFeeDescription": "Esta tarifa se cobra al unirse a la lista de espera.",
    "book": "Reservar",
    "booking": "Reservando",
    "joinWaitlist": "Ponme en la lista de espera",
    "paymentRequiredForWaitlist": "Se requiere una tarjeta registrada para unirse a la lista de espera.",
    "yourCardWillBeChargedToday": "Tu tarjeta será cobrada hoy",
    "legalText": "Al reservar una cita, aceptas los",
    "termsOfService": "Términos de Servicio",
    "and": "y la",
    "privacyPolicy": "Política de Privacidad",
    "userInformation": {
      "title": "Tu información",
      "firstNameLabel": "NOMBRE",
      "firstNamePlaceholder": "Nombre *",
      "lastNameLabel": "APELLIDO",
      "lastNamePlaceholder": "Apellido *",
      "phoneLabel": "TELÉFONO",
      "phonePlaceholder": "Teléfono *",
      "emailLabel": "CORREO ELECTRÓNICO",
      "emailPlaceholder": "Correo electrónico *",
      "validation": {
        "firstNameRequired": "El nombre es obligatorio",
        "firstNameInvalid": "El nombre no puede contener números",
        "lastNameRequired": "El apellido es obligatorio",
        "lastNameInvalid": "El apellido no puede contener números",
        "phoneInvalid": "Por favor ingresa un número de teléfono válido",
        "emailInvalid": "Por favor ingresa un correo electrónico válido",
        "emailRequired": "El correo electrónico es obligatorio",
        "paymentMethodRequired": "Selecciona un método de pago"
      },
      "accessibility": {
        "firstNameInput": "Nombre",
        "lastNameInput": "Apellido",
        "phoneInput": "Número de teléfono",
        "phoneInputHint": "Ingresa tu número de teléfono con código de país",
        "emailInput": "Dirección de correo electrónico"
      }
    },
    "accessibility": {
      "shopImage": "Foto de {{name}}",
      "paymentMethod": "Método de pago {{method}}",
      "paymentMethodHint": "Selecciona {{method}} como tu método de pago",
      "bookButton": "Reservar cita",
      "bookButtonHint": "Confirmar y reservar tu cita",
      "loading": "Cargando"
    }
  },
  "RescheduleAppointmentScreen": {
    "title": "Reprogramar Cita",
    "currentAppointment": "Cita actual",
    "minutesAbbreviation": "min",
    "newAppointment": "Nueva cita",
    "selectNewTime": "Selecciona una nueva fecha y hora",
    "rescheduleButton": "Reprogramar Cita",
    "cancelButton": "Cancelar",
    "successMessage": "Cita reprogramada exitosamente",
    "error": "No se pudieron cargar los datos de la cita. Por favor, inténtalo de nuevo.",
    "tryAgain": "Intentar de nuevo",
    "errorMessage": "No se pudo reprogramar la cita",
    "errorDescription": "Por favor intenta de nuevo o contacta a soporte",
    "sameTimeError": "Por favor selecciona una hora diferente",
    "noTimeSelected": "Por favor selecciona una nueva hora",
    "pastTimeError": "No se puede seleccionar una hora en el pasado",
    "loadingSchedule": "Cargando horarios disponibles...",
    "noAvailableTimes": "No hay horarios disponibles para esta fecha",
    "barberDoesNotAllowReschedule": "Este barbero no permite reprogramar dentro de este plazo",
    "timeSlotUnavailable": "Este horario ya no está disponible",
    "cannotReschedulePast": "No se pueden reprogramar citas pasadas",
    "accessibility": {
      "rescheduleButton": "Reprogramar cita a la hora seleccionada",
      "backButton": "Cancelar y volver"
    }
  },
  "CashAppBottomSheet": {
    "title": "Escanear con Cash App",
    "timeRemaining": "Tiempo restante",
    "instructions": "Abre Cash App en tu teléfono y escanea este código QR para completar tu pago",
    "troubleshooting": "¿Tienes problemas? Asegúrate de tener Cash App instalado y haber iniciado sesión.",
    "qrCodeExpired": "Código QR expirado",
    "qrCodeExpiredDescription": "El código QR ha expirado. Por favor, haz clic en Reintentar para generar un nuevo código QR.",
    "retry": "Reintentar",
    "openInCashApp": "o haz clic aquí para abrir Cash App",
    "error": {
      "loadingQRCode": "Error al cargar el código QR. Por favor, inténtalo de nuevo."
    },
    "accessibility": {
      "closeButton": "Cerrar pago con Cash App",
      "closeButtonHint": "Cerrar el escáner de código QR de Cash App",
      "qrCode": "Código QR de pago de Cash App"
    }
  },
  "CheckoutFormBottomSheet": {
    "cardDetails": "Detalles de la tarjeta",
    "cardOnFileRequired": "Se requiere tarjeta en archivo",
    "book": "Reservar",
    "booking": "Reservando",
    "buyGiftCard": "Comprar tarjeta de regalo",
    "buyingGiftCard": "Comprando tarjeta de regalo",
    "pay": "Pagar",
    "joinWaitlist": "Ponme en la lista de espera"
  },
  "LegalBottomSheet": {
    "termsTitle": "Términos de Servicio",
    "privacyTitle": "Política de Privacidad",
    "errorTitle": "Error al cargar contenido",
    "errorMessage": "Por favor verifica tu conexión a internet e intenta de nuevo."
  },
  "ReferralBanner": {
    "accessibilityLabel": "Conviértete en embajador de marca y gana dinero",
    "eyebrow": "Embajador de marca",
    "headline": "¡Conviértete en\nembajador de marca\ny gana dinero!"
  },
  "ReferralWebViewScreen": {
    "title": "Programa de referidos",
    "loadingLabel": "Cargando programa de referidos"
  },
  "CookieConsent": {
    "thisSiteUsesCookie": "Este sitio utiliza cookies",
    "manageYourPrivacyChoices": "Gestiona tus elecciones de privacidad",
    "here": "aquí",
    "accept": "Aceptar",
    "consentTab": "Consentimiento",
    "detailsTab": "Detalles",
    "aboutTab": "Acerca de",
    "consentContent": "Utilizamos cookies para mejorar la experiencia del usuario y analizar el tráfico del sitio web. Por estas razones, también podemos compartir información sobre su uso de nuestro sitio con nuestros socios de análisis. Al hacer clic en Permitir todo, usted consiente almacenar en su dispositivo todas las tecnologías descritas en nuestra Política de Cookies. Puede cambiar la configuración de cookies haciendo clic en Personalizar.",
    "detailsContent": "Detalles",
    "aboutContent": "Las cookies son pequeños archivos de texto que los sitios web pueden usar para hacer que la experiencia del usuario sea más eficiente. La ley establece que podemos almacenar cookies en su dispositivo si son estrictamente necesarias para el funcionamiento de este sitio. Para todos los demás tipos de cookies, necesitamos su permiso. Este sitio utiliza diferentes tipos de cookies. Algunas cookies son colocadas por servicios de terceros que aparecen en nuestras páginas. Para obtener más información sobre nuestro uso de cookies, puede ver nuestra Política de Cookies. Consulte nuestra Política de Cookies. Obtenga más información sobre quiénes somos, cómo puede contactarnos y cómo procesamos datos personales en nuestra Política de Privacidad. Consulte nuestra",
    "privacyPolicyLink": "Política de Privacidad",
    "denyButton": "Denegar",
    "rejectButton": "Descartar",
    "allowSelection": "Permitir selección",
    "manage": "Administrar",
    "allowAllButton": "Permitir todo"
  },
  "CookieConsentDetails": {
    "trackerCount": "{{count}} rastreadores",
    "trackerCount_one": "{{count}} rastreador",
    "trackerCount_other": "{{count}} rastreadores",
    "toggleCategory": "Alternar {{category}}",
    "denyButton": "Denegar",
    "allowSelectionButton": "Permitir selección",
    "allowAllButton": "Permitir todo",
    "backButton": "Atrás",
    "expiry": "Caducidad",
    "type": "Tipo",
    "month": "{{count}} mes",
    "month_one": "{{count}} mes",
    "month_other": "{{count}} meses",
    "year": "{{count}} año",
    "year_one": "{{count}} año",
    "year_other": "{{count}} años",
    "minute": "{{count}} minuto",
    "minute_one": "{{count}} minuto",
    "minute_other": "{{count}} minutos",
    "hour": "{{count}} hora",
    "hour_one": "{{count}} hora",
    "hour_other": "{{count}} horas",
    "categories": {
      "necessary": {
        "title": "Necesarias",
        "description": "Utilizamos cookies necesarias para ayudar a hacer que nuestro sitio web sea lo más fácil de usar posible, permitiendo la navegación de la experiencia de reserva, servicios de programación y realización de pagos."
      },
      "statistical": {
        "title": "Estadísticas",
        "description": "Utilizamos cookies estadísticas para ayudarnos a entender cómo interactúa con nuestro sitio web mediante la recopilación y el informe de información de forma anónima."
      }
    },
    "trackers": {
      "stripe": {
        "name": "Stripe",
        "description": "Utilizamos Stripe para el procesamiento de pagos y almacenamos sus cookies para garantizar el funcionamiento adecuado.",
        "__stripe_sid": {
          "description": "Establecida por Stripe para la prevención de fraude."
        },
        "__stripe_mid": {
          "description": "Establecida por Stripe para la prevención de fraude."
        },
        "m": {
          "description": "Establecida por Stripe para la prevención de fraude."
        },
        "cookie-perms": {
          "description": "Almacena sus preferencias de consentimiento de cookies."
        }
      },
      "google": {
        "name": "Google",
        "description": "Utilizamos Google para varios servicios como Google Pay y Google Calendar y almacenamos sus cookies para garantizar el funcionamiento adecuado.",
        "G_ENABLED_IDPS": {
          "description": "Establecida por Google para habilitar el inicio de sesión único."
        },
        "NID": {
          "description": "Establecida para el funcionamiento adecuado de los servicios de Google."
        },
        "1P_JAR": {
          "description": "Establecida para el funcionamiento adecuado de los servicios de Google."
        },
        "SID": {
          "description": "Establecida para el funcionamiento adecuado de los servicios de Google."
        },
        "SSID": {
          "description": "Establecida para el funcionamiento adecuado de los servicios de Google."
        },
        "HSID": {
          "description": "Establecida para el funcionamiento adecuado de los servicios de Google."
        },
        "SIDCC": {
          "description": "Establecida para el funcionamiento adecuado de los servicios de Google."
        },
        "APISID": {
          "description": "Establecida para el funcionamiento adecuado de los servicios de Google."
        },
        "__Secure-1PSID": {
          "description": "Establecida para el funcionamiento adecuado de los servicios de Google."
        },
        "__Secure-1PAPISID": {
          "description": "Establecida para el funcionamiento adecuado de los servicios de Google."
        },
        "__Secure-3PAPISID": {
          "description": "Establecida para el funcionamiento adecuado de los servicios de Google."
        },
        "__Secure-3PSID": {
          "description": "Establecida para el funcionamiento adecuado de los servicios de Google."
        },
        "__Secure-3PSIDCC": {
          "description": "Establecida para el funcionamiento adecuado de los servicios de Google."
        },
        "__Secure-APISID": {
          "description": "Establecida para el funcionamiento adecuado de los servicios de Google."
        },
        "__Secure-HSID": {
          "description": "Establecida para el funcionamiento adecuado de los servicios de Google."
        },
        "__Secure-SSID": {
          "description": "Establecida para el funcionamiento adecuado de los servicios de Google."
        }
      },
      "cloudflare": {
        "name": "Cloudflare",
        "description": "Utilizamos Cloudflare para garantizar una experiencia de usuario agradable y almacenamos varias cookies para maximizar los recursos de red, gestionar el tráfico y proteger nuestros sitios del tráfico malicioso.",
        "__cf_bm": {
          "description": "Establecida para el funcionamiento adecuado de la funcionalidad de gestión de bots o lucha contra bots."
        }
      },
      "google-analytics": {
        "name": "Google Analytics",
        "description": "Utilizamos Google Analytics para comprender cómo los visitantes interactúan con nuestro sitio web.",
        "DV": {
          "description": "Establecida por Google Analytics para recopilar información sobre cómo los visitantes usan nuestro sitio."
        },
        "OTZ": {
          "description": "Establecida por Google Analytics para recopilar información sobre cómo los visitantes usan nuestro sitio."
        },
        "_gat": {
          "description": "Establecida por Google Analytics para limitar la tasa de solicitudes."
        },
        "_gid": {
          "description": "Establecida por Google Analytics para distinguir usuarios."
        }
      },
      "facebook-pixel": {
        "name": "Facebook Pixel",
        "description": "Utilizamos Facebook Pixel para medir la efectividad de la publicidad y entregar anuncios relevantes.",
        "_fbp": {
          "description": "Establecida por Facebook para entregar publicidad y rastrear conversiones."
        },
        "fr": {
          "description": "Establecida por Facebook para entregar publicidad y medir el rendimiento de los anuncios."
        },
        "datr": {
          "description": "Establecida por Facebook para identificar navegadores web con fines de seguridad."
        }
      }
    }
  },
  "DeleteServiceConfirmationBottomSheet": {
    "removeService": {
      "subtitle": "Eliminar este servicio también eliminará los siguientes complementos, ya que requieren un servicio principal.",
      "confirm": "Eliminar servicio y complementos",
      "dismiss": "Mantener todo"
    }
  },
  "BnplBottomSheet": {
    "title": "Compra ahora, paga después",
    "stripeNotReady": "El servicio de pago no está disponible. Inténtalo de nuevo.",
    "failedToCreateIntent": "No se pudo iniciar el pago. Inténtalo de nuevo.",
    "missingCustomerInfo": "No se puede procesar el pago. Inténtalo de nuevo.",
    "missingCustomer": "Falta información del cliente. Inténtalo de nuevo.",
    "next": "Siguiente"
  },
  "BnplReturnScreen": {
    "loading": "Procesando",
    "sessionExpired": "Tu sesión ha expirado",
    "error": "Algo salió mal",
    "cancelledToast": "El pago fue cancelado o falló",
    "goHome": "Ir al inicio"
  },
  "ManageNotificationsBottomSheet": {
    "title": "Gestionar notificaciones",
    "save": "Guardar",
    "confirm": "Confirmación",
    "reschedule": "Reprogramar",
    "cancel": "Cancelación",
    "errorMessage": "Error al actualizar notificaciones. Por favor, inténtalo de nuevo.",
    "pushNotifications": "Notificaciones push",
    "pushEnabled": "Activado",
    "pushDisabled": "Desactivado"
  },
  "NotificationSectionRow": {
    "phone": "SMS",
    "email": "Correo",
    "push": "Push"
  },
  "CashAppReturnScreen": {
    "loading": "Procesando",
    "sessionExpired": "Tu sesión ha expirado. Por favor, inténtalo de nuevo.",
    "error": "Algo salió mal. Por favor, inténtalo de nuevo.",
    "cancelledToast": "El pago fue cancelado.",
    "goHome": "Ir al inicio"
  },
  "AccountDeletion": {
    "choice": {
      "title": "¿Deseas deshabilitar o eliminar tu cuenta?",
      "disable": {
        "title": "Deshabilitar cuenta",
        "description": "Deshabilitaremos tu(s) cuenta(s) en las aplicaciones con tecnología de Squire."
      },
      "delete": {
        "title": "Eliminar cuenta",
        "description": "Borraremos todos tus datos de todas las aplicaciones y servicios con tecnología de Squire."
      },
      "cancel": "Cancelar",
      "continue": "Continuar"
    },
    "disable": {
      "header": "¿Estás seguro de que deseas deshabilitar tu cuenta?",
      "cards": {
        "0": {
          "title": "Tu cuenta será deshabilitada",
          "description": "Deshabilitaremos tu cuenta de Squire y ya no podrás iniciar sesión en ningún servicio con tecnología de Squire."
        },
        "1": {
          "title": "Los barberos aún pueden acceder a tus datos",
          "description": "Tu barbero puede seguir contactándote sobre citas o enviarte mensajes de marketing."
        },
        "2": {
          "title": "Las citas futuras no serán canceladas",
          "description": "Todas tus citas futuras y membresías seguirán activas."
        },
        "3": {
          "title": "Es posible restaurar tu cuenta",
          "description": "Para restaurar tu cuenta, comunícate con techsupport@getsquire.com"
        }
      },
      "primary": "Deshabilitar cuenta",
      "secondary": "Mantener cuenta"
    },
    "delete": {
      "header": "¿Estás seguro de que deseas eliminar tu cuenta?",
      "cards": {
        "0": {
          "title": "Todos tus datos serán eliminados",
          "description": "Borraremos todos tus datos de todas las aplicaciones y servicios de Squire, incluyendo las aplicaciones de barberos con tecnología de Squire."
        },
        "1": {
          "title": "No somos responsables de contactos futuros",
          "description": "No somos responsables si tu barbero continúa contactándote de forma independiente."
        },
        "2": {
          "title": "Las citas serán canceladas",
          "description": "Todas tus citas futuras y membresías serán canceladas. La política de cancelación de tu barbero sigue aplicando."
        },
        "3": {
          "title": "Es permanente",
          "description": "Una vez eliminada, esto no puede deshacerse."
        }
      },
      "primary": "Eliminar cuenta",
      "secondary": "Mantener cuenta"
    },
    "toast": {
      "successDisabled": "Tu cuenta fue deshabilitada exitosamente",
      "successDeleted": "Tu cuenta fue eliminada exitosamente",
      "error": "Algo salió mal"
    }
  },
  "StandbyRegistrationScreen": {
    "branding": {
      "headline": "Únete a la lista de espera.",
      "poweredBy": "Con la tecnología de"
    },
    "closed": {
      "title": "La lista de espera está cerrada.",
      "bookButton": "Reservar próxima cita",
      "bookButtonHint": "Abre la página de reservas de este local"
    },
    "enterPhone": {
      "title": "Ingresa tu teléfono",
      "subtitle": "Comprobaremos si ya tienes una cuenta.",
      "phoneLabel": "Teléfono",
      "placeholder": "(555) 123-4567",
      "invalid": "Ingresa un número de teléfono válido"
    },
    "footnote": {
      "sms": "Al continuar, aceptas recibir mensajes de texto de SQUIRE al número proporcionado. Pueden aplicarse tarifas de mensajes y datos.",
      "legal": "Al continuar, aceptas los <tosLink>Términos de servicio</tosLink> y la <privacyLink>Política de privacidad</privacyLink>, incluida la recepción de mensajes transaccionales y de marketing de SQUIRE."
    },
    "otp": {
      "title": "Ingresa el código",
      "subtitle": "Ingresa el código de 6 dígitos que enviamos a tu teléfono.",
      "error": "Ese código no funcionó. Inténtalo de nuevo.",
      "expired": "Este código venció. Solicita uno nuevo abajo."
    },
    "confirmSession": {
      "title": "¿Continuar como {{firstName}}?",
      "subtitle": "Encontramos una sesión existente en este dispositivo.",
      "confirm": "Sí, soy yo",
      "notYou": "¿No eres tú?",
      "exitTitle": "¿Salir de la lista de espera?",
      "exitSubtitle": "Si vuelves atrás, saldrás de la lista de espera. Tendrás que verificar tu número de teléfono otra vez para empezar de nuevo.",
      "exitStay": "Quedarme y continuar",
      "exitLeave": "Salir y empezar de nuevo"
    },
    "details": {
      "title": "Agrega tus datos",
      "eyebrow": "Parece que eres nuevo aquí",
      "firstName": "Nombre",
      "firstNamePlaceholder": "Derek",
      "lastName": "Apellido",
      "lastNamePlaceholder": "Jackson",
      "email": "Correo electrónico",
      "emailPlaceholder": "email@squire.com",
      "phone": "Teléfono",
      "birthday": "Cumpleaños",
      "birthdayPlaceholder": "MM/DD/AAAA",
      "avatarLabel": "Agrega una foto de perfil",
      "errors": {
        "birthdayRequired": "Ingresa tu cumpleaños",
        "birthdayInvalid": "Ingresa una fecha válida"
      }
    },
    "cta": {
      "continue": "Continuar",
      "back": "Atrás",
      "close": "Cerrar"
    },
    "unavailable": {
      "title": "Esta página no está disponible",
      "genericBody": "Esta lista de espera no está disponible en este momento.",
      "disabledBody": "Este local no está aceptando registros en la lista de espera en este momento.",
      "errorTitle": "Algo salió mal",
      "errorBody": "No pudimos cargar esta página.",
      "retry": "Reintentar"
    },
    "errors": {
      "throttled": "Demasiados intentos. Espera un momento e inténtalo de nuevo.",
      "submit": "Algo salió mal. Inténtalo de nuevo."
    },
    "accessibility": {
      "backButton": "Atrás",
      "backButtonHint": "Vuelve al paso anterior",
      "closeButton": "Cerrar",
      "closeButtonHint": "Cierra la verificación y vuelve al paso del teléfono",
      "phoneInput": "Número de teléfono",
      "phoneInputHint": "Ingresa tu número de celular para recibir un código de verificación",
      "phoneContinueButton": "Continuar",
      "phoneContinueButtonHint": "Envía un código de verificación a tu teléfono",
      "otpInput": "Código de verificación",
      "otpInputHint": "Ingresa el código de 6 dígitos enviado a tu teléfono",
      "otpContinueButton": "Verificar",
      "otpContinueButtonHint": "Verifica el código que ingresaste",
      "detailsContinueButton": "Continuar",
      "detailsContinueButtonHint": "Te une a la lista de espera con tus datos",
      "birthdayInput": "Fecha de nacimiento",
      "birthdayInputHint": "Ingresa tu fecha de nacimiento en mes, día y año",
      "confirmButton": "Continuar",
      "confirmButtonHint": "Continúa con tu cuenta iniciada",
      "notYouButton": "¿No eres tú?",
      "notYouButtonHint": "Cierra la sesión para usar otro número de teléfono",
      "exitStayButton": "Quedarme y continuar",
      "exitStayButtonHint": "Permanece en la lista de espera y continúa",
      "exitLeaveButton": "Salir y empezar de nuevo",
      "exitLeaveButtonHint": "Sale de la lista de espera; tendrás que verificar tu número de teléfono otra vez",
      "retryButton": "Reintentar",
      "retryButtonHint": "Vuelve a cargar la página de lista de espera"
    }
  },
  "StandbyStylistScreen": {
    "title": "Selecciona un estilista",
    "anyTitle": "Cualquier profesional",
    "anySubtitle": "Asignación automática según disponibilidad",
    "continue": "Continuar",
    "error": "No pudimos cargar los estilistas.",
    "retry": "Reintentar",
    "empty": "No hay estilistas disponibles.",
    "accessibility": {
      "continueButton": "Continuar",
      "continueButtonHint": "Continúa a la selección de servicio",
      "retryButton": "Reintentar",
      "retryButtonHint": "Vuelve a cargar la lista de estilistas"
    }
  },
  "StandbySummaryScreen": {
    "title": "Resumen",
    "stylistLabel": "Profesional",
    "serviceLabel_one": "Servicio",
    "serviceLabel_other": "Servicios",
    "priceLabel": "Precio",
    "durationLabel": "Duración",
    "error": "No pudimos cargar tu resumen",
    "retry": "Reintentar",
    "join": "Unirse a la lista de espera",
    "joinError": "No pudimos unirte a la lista de espera. Intenta de nuevo.",
    "alreadyOnListToast": "Ya estás en la lista de espera de hoy.",
    "accessibility": {
      "joinButton": "Unirse a la lista de espera",
      "joinButtonHint": "Envía tu solicitud para unirte",
      "retryButton": "Reintentar",
      "retryButtonHint": "Vuelve a cargar tu resumen"
    }
  },
  "StandbyServiceScreen": {
    "title": "Selecciona servicios",
    "searchPlaceholder": "Buscar servicios",
    "categoryAll": "Todos",
    "categoryCount": "{{name}} ({{count}})",
    "continue": "Continuar",
    "empty": "No hay servicios disponibles.",
    "filteredEmpty": "Ningún servicio coincide con tu búsqueda.",
    "error": "No pudimos cargar los servicios.",
    "retry": "Reintentar",
    "durationMinutes": "{{count}} min",
    "durationHours": "{{count}} h",
    "durationHourMinutes": "{{hours}} h {{minutes}} min",
    "accessibility": {
      "continueButton": "Continuar",
      "continueButtonHint": "Continúa al resumen",
      "retryButton": "Reintentar",
      "retryButtonHint": "Vuelve a cargar la lista de servicios"
    }
  },
  "StandbyEntriesScreen": {
    "title": "Lista de espera",
    "closeButton": "Cerrar lista de espera",
    "closeButtonHint": "Vuelve a la pantalla anterior",
    "subtitle": {
      "any": "Esperando a cualquier profesional",
      "waitingFor": "Esperando a {{name}}"
    },
    "offer": "{{time}} con {{name}}",
    "empty": "No estás en ninguna lista de espera",
    "today": "Hoy",
    "tomorrow": "Mañana",
    "errorToast": "No pudimos cargar tu lista de espera. Inténtalo de nuevo.",
    "accessibility": {
      "row": "Abre esta solicitud de lista de espera",
      "countdown": "La oferta vence en {{time}}"
    }
  },
  "StandbyEntryStatusScreen": {
    "waiting": {
      "title": "Estás en la lista",
      "subtitle": "Cuando se libere un lugar, te avisaremos para que puedas aceptar y pagar, o rechazar y seguir en la lista."
    },
    "offer": {
      "title": "Encontramos un lugar para ti",
      "subtitle": "Acepta para reservar y continuar con el pago, o rechaza para seguir en la lista y esperar otra apertura.",
      "countdown": "Esperando tu respuesta ({{time}})",
      "dateLabel": "Fecha",
      "timeLabel": "Hora",
      "professionalLabel": "Profesional",
      "dateToday": "Hoy, {{date}}",
      "dateTomorrow": "Mañana, {{date}}",
      "accept": "Aceptar y pagar",
      "decline": "Rechazar y seguir en la lista"
    },
    "declined": {
      "heading": "Estás en la lista",
      "bannerTitle": "Sigues en la lista de espera",
      "bannerBody": "Seguiremos atentos a otro lugar disponible."
    },
    "expired": {
      "bannerTitle": "Este lugar ya no está disponible",
      "bannerBody": "El lugar expiró o fue cancelado. Seguiremos buscando otro."
    },
    "dayEnded": {
      "title": "Hoy no hay lugares disponibles",
      "body": "Hoy no hubo suerte, pero tu próximo corte está cerca. Reserva la próxima fecha disponible o únete a la lista de espera de mañana.",
      "bookCta": "Reservar la próxima fecha disponible",
      "joinCta": "Unirte a la lista de mañana"
    },
    "error": "Algo salió mal",
    "retry": "Reintentar",
    "summaryLabel": "Resumen",
    "unpaid": "Sin pagar",
    "servicesLabel_one": "Servicio",
    "servicesLabel_other": "Servicios",
    "stylistLabel": "Profesional",
    "joinedForLabel": "Te uniste a la lista para el",
    "accessibility": {
      "retryButton": "Reintentar",
      "retryButtonHint": "Vuelve a cargar tu solicitud de lista de espera",
      "leaveButton": "Salir de la lista de espera",
      "leaveButtonHint": "Abre una confirmación para salir de la lista de espera",
      "acceptButtonHint": "Abre el pago para esta cita",
      "declineButtonHint": "Abre una confirmación para rechazar esta oferta",
      "dismissBanner": "Descartar",
      "bookButtonHint": "Abre la reserva para elegir tu próxima cita",
      "joinButtonHint": "Te agrega a la lista de espera de mañana",
      "joiningStandby": "Uniéndote a la lista de mañana",
      "joinStandbyError": "No pudimos agregarte a la lista de mañana. Inténtalo de nuevo."
    },
    "leave": "Salir de la lista de espera",
    "toast": {
      "left": "Saliste de esta lista de espera. Puedes unirte de nuevo abajo.",
      "postLeave": "Saliste de la lista de espera.",
      "expired": "Esta lista de espera cerró por hoy.",
      "booked": "Tu cita está confirmada. Revisa tus mensajes para ver los detalles.",
      "unavailable": "Este enlace ya no es válido.",
      "invalidShop": "El ID del negocio que ingresaste no es válido."
    }
  },
  "StandbyEntryDrawer": {
    "waiting": {
      "title": "Estás en la lista",
      "subtitle": "Cuando se libere un lugar, podrás aceptar y pagar o rechazar y seguir esperando.",
      "pill": "En espera"
    },
    "offered": {
      "title": "Encontramos un lugar para ti",
      "subtitle": "Acepta y paga, o rechaza para seguir en la lista y esperar otra apertura.",
      "accept": "Aceptar y pagar",
      "decline": "Rechazar y seguir en la lista"
    },
    "details": {
      "date": "Fecha",
      "duration": "Duración",
      "total": "Precio total"
    },
    "timePreference": {
      "morning": "Horario de la mañana",
      "afternoon": "Horario de la tarde",
      "evening": "Horario de la noche",
      "afterHours": "Fuera de horario"
    },
    "banner": {
      "expired": {
        "title": "El lugar ya no está disponible",
        "body": "El lugar venció o fue cancelado. Seguiremos buscando otro."
      },
      "declined": {
        "title": "Sigues en la lista de espera",
        "body": "Estaremos atentos a otro lugar."
      },
      "dismiss": "Descartar",
      "dismissHint": "Descarta este aviso"
    },
    "leave": "Salir de la lista de espera",
    "accessibility": {
      "leaveButton": "Salir de la lista de espera",
      "leaveButtonHint": "Abre una confirmación para salir de la lista de espera",
      "acceptButton": "Aceptar y pagar",
      "acceptButtonHint": "Abre el pago para esta cita",
      "declineButton": "Rechazar y seguir en la lista",
      "declineButtonHint": "Rechaza este lugar y te mantiene en la lista de espera"
    }
  },
  "StandbyHomeCard": {
    "header": "Lista de espera",
    "waiting": "En espera",
    "joinedOne": "En la lista de {{shop}}.",
    "joinedMany": "En la lista de {{count}} barberías.",
    "offerOne": "{{stylist}} tiene un hueco a las {{time}} en {{shop}}.",
    "offerMany": "Tienes huecos disponibles en {{count}} barberías.",
    "accessibility": {
      "timeLeft": "{{time}} restante",
      "hintEntry": "Abre tu entrada de la lista de espera",
      "hintList": "Abre tu lista de espera"
    }
  },
  "StandbyLeaveSheet": {
    "title": "¿Salir de la lista de espera?",
    "message": "Se te quitará de la lista y no recibirás avisos de lugares disponibles.",
    "leave": "Salir de la lista de espera",
    "close": "Cerrar",
    "error": "No se pudo salir de la lista. Inténtalo de nuevo.",
    "accessibility": {
      "leaveButton": "Salir de la lista de espera",
      "leaveButtonHint": "Te quita de la lista de espera",
      "closeButton": "Cerrar",
      "closeButtonHint": "Te mantiene en la lista y cierra este diálogo"
    }
  },
  "StandbyDeclineSheet": {
    "title": "¿Rechazar este lugar?",
    "body": "Seguirás en la lista de espera y seguiremos buscando otra apertura.",
    "confirm": "Rechazar y seguir en la lista",
    "close": "Mantener este lugar",
    "error": "No se pudo rechazar la oferta. Inténtalo de nuevo.",
    "errorToast": "Esta oferta ya no está disponible.",
    "accessibility": {
      "confirmButton": "Rechazar y seguir en la lista",
      "confirmButtonHint": "Rechaza esta oferta y te mantiene en la lista de espera",
      "closeButton": "Mantener este lugar",
      "closeButtonHint": "Cierra este diálogo y conserva la oferta"
    }
  },
  "StandbyCheckoutScreen": {
    "title": "Tu pedido",
    "timeToPay": "Tiempo para pagar - ",
    "stylistLabel": "Profesional",
    "anyProfessionalLabel": "Cualquier profesional",
    "dateAndTimeLabel": "Fecha y hora",
    "dateAndTimeValue": "{{date}}, a las {{time}}",
    "durationMinutes_one": "{{count}} min",
    "durationMinutes_other": "{{count}} min",
    "servicesLabel": "Servicios",
    "taxesAndFeesLabel": "Impuestos y cargos",
    "giftCard": "Tarjeta de regalo",
    "tipLabel": "Propina",
    "promoPlaceholder": "Agrega una tarjeta de regalo o código promocional",
    "redeem": "Aplicar",
    "continue": "Continuar",
    "payInPerson": "Pagar en el local",
    "paymentStepPlaceholder": "Método de pago",
    "promoInvalidError": "Este código no es válido.",
    "paymentFailedError": "El pago no se procesó. Inténtalo de nuevo.",
    "cartMismatchError": "Tu pedido se actualizó. Revísalo antes de continuar.",
    "accessibility": {
      "countdown": "Tiempo para pagar, {{time}}",
      "stylistRow": "Profesional, {{name}}",
      "dateAndTimeRow": "Fecha y hora, {{date}}, {{duration}}",
      "serviceRow": "{{name}}, {{price}}",
      "promoInput": "Código promocional o de tarjeta de regalo",
      "promoInputHint": "Ingresa un código promocional o el número de una tarjeta de regalo",
      "redeemButtonHint": "Aplica el código a tu pedido",
      "removeCodeButton": "Quitar código",
      "removeCodeButtonHint": "Quita el código aplicado de tu pedido",
      "continueHint": "Avanza al paso de pago",
      "payInPersonHint": "Reserva esta cita para pagar en el local",
      "loading": "Cargando tu pedido",
      "closeButton": "Cerrar",
      "closeButtonHint": "Cierra el pago y vuelve a tu oferta de la lista de espera"
    }
  },
  "StandbyPaymentMethod": {
    "title": "Método de pago",
    "payTotal": "Pagar {{total}}",
    "confirm": "Confirmar",
    "walletError": "El pago no se procesó. Inténtalo de nuevo.",
    "accessibility": {
      "closeButton": "Cerrar",
      "closeButtonHint": "Vuelve a tu pedido sin perder el carrito",
      "payButtonHint": "Completa tu pago y reserva la cita",
      "backButton": "Atrás",
      "backButtonHint": "Vuelve a la lista de métodos de pago"
    }
  },
  "StandbyOrderConfirmedScreen": {
    "title": "¡Tu pedido está confirmado!",
    "confirmationCodeLabel": "Código de confirmación",
    "addToCalendarLabel": "Agregar al calendario",
    "rescheduleAppointment": "Reprogramar cita",
    "cancelAppointment": "Cancelar cita",
    "successFallback": {
      "title": "¡Ya tienes tu reserva!",
      "subtitle": "Tu reserva está confirmada. Estamos teniendo problemas para cargar los detalles completos de la confirmación en este momento.",
      "toast": "No pudimos cargar los detalles de tu confirmación."
    },
    "shopCard": {
      "getDirections": "Cómo llegar",
      "paymentDetailsLabel": "Detalles del pago",
      "chargeTodayDisclaimer": "Se cobrará a tu tarjeta hoy.",
      "paymentPendingBadge": "Pago pendiente",
      "paidBadge": "Pagado",
      "payInPersonValue": "Pagar en el local",
      "unpaidBadge": "Sin pagar"
    },
    "accessibility": {
      "mapPreview": "Vista previa del mapa de la ubicación del negocio",
      "confirmationCode": "Código de confirmación {{code}}",
      "addAppleCalendar": "Agregar a Apple Calendar",
      "addGoogleCalendar": "Agregar a Google Calendar",
      "rescheduleButtonHint": "Abre el proceso para reprogramar esta cita",
      "cancelButtonHint": "Abre una confirmación para cancelar esta cita",
      "closeButton": "Cerrar",
      "closeButtonHint": "Cierra la confirmación"
    }
  },
  "CustomerNotificationView": {
    "unavailable": {
      "title": "Esta notificación ya no está disponible",
      "subtitle": "Es posible que el enlace haya caducado. Si aún necesitas ayuda, comunícate con tu barbería o con el soporte de Squire."
    },
    "supportFooter": "Si este mensaje no era para ti, comunícate con nosotros en support@getsquire.com"
  },
  "StandbyWaitlistJoinedScreen": {
    "title": "{{name}}, ya estás en la lista de espera",
    "leave": "Salir de la lista de espera",
    "left": "Saliste de la lista de espera.",
    "throttled": "Demasiados intentos. Espera un momento e inténtalo de nuevo.",
    "leaveError": "No se pudo salir de la lista. Inténtalo de nuevo.",
    "accessibility": {
      "close": "Cerrar",
      "closeHint": "Vuelve a la página de reservas de la barbería",
      "leaveHint": "Te quita de esta lista de espera de inmediato"
    }
  }
}
